module.exports = {
	"v": "4.5.9",
	"fr": 29.9700012207031,
	"ip": 14.0000005702317,
	"op": 594.000024194116,
	"w": 450,
	"h": 420,
	"ddd": 0,
	"assets": [
		{
			"id": "comp_0",
			"layers": [
				{
					"ddd": 0,
					"ind": 0,
					"ty": 4,
					"nm": "\r01_auth0",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								655.919,
								615.669,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								-139.581,
								-75.831,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											5.339,
											5.339
										]
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.03
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.863,
											0.314,
											0.145,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											-139.581,
											4.669
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667,
														0.667
													],
													"y": [
														1,
														1
													]
												},
												"o": {
													"x": [
														0.985,
														0.985
													],
													"y": [
														-0.011,
														-0.011
													]
												},
												"n": [
													"0p667_1_0p985_-0p011",
													"0p667_1_0p985_-0p011"
												],
												"t": 43.371,
												"s": [
													0,
													0
												],
												"e": [
													100,
													100
												]
											},
											{
												"t": 49.0000019958109
											}
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-139.5,
													4
												],
												[
													-139.5,
													-335
												]
											],
											"c": false
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.03
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 1.033
											}
										},
										{
											"n": "g",
											"nm": "gap",
											"v": {
												"a": 0,
												"k": 3
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.09,
											0.122,
											0.235,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tm",
									"s": {
										"a": 0,
										"k": 0,
										"ix": 1
									},
									"e": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.794
													],
													"y": [
														-0.011
													]
												},
												"n": [
													"0p667_1_0p794_-0p011"
												],
												"t": 46,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 58.0000023623884
											}
										],
										"ix": 2
									},
									"o": {
										"a": 0,
										"k": 0,
										"ix": 3
									},
									"m": 2,
									"ix": 4,
									"nm": "Trim Paths 1",
									"mn": "ADBE Vector Filter - Trim"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 4,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 612.000024927271,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "circle auth0 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.963
										],
										"y": [
											-0.008
										]
									},
									"n": [
										"0p667_1_0p963_-0p008"
									],
									"t": 58,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 62.0000025253118
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								655.947,
								337.686,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.947,
								89.686,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667,
											0.667,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.893,
											0.893,
											0.333
										],
										"y": [
											-0.018,
											-0.018,
											0.333
										]
									},
									"n": [
										"0p667_1_0p893_-0p018",
										"0p667_1_0p893_-0p018",
										"0p667_0p667_0p333_0p333"
									],
									"t": 58,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 64.0000026067734
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.205,
													"y": 1
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"n": "0p205_1_0p333_0",
												"t": 62,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																-6.589
															],
															[
																-6.589,
																0
															],
															[
																0,
																0
															],
															[
																0,
																6.589
															],
															[
																6.589,
																0
															]
														],
														"o": [
															[
																-6.589,
																0
															],
															[
																0,
																6.589
															],
															[
																0,
																0
															],
															[
																6.589,
																0
															],
															[
																0,
																-6.589
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																1.134,
																-11.95
															],
															[
																-10.816,
																0
															],
															[
																1.134,
																11.949
															],
															[
																0.865,
																11.949
															],
															[
																12.815,
																0
															],
															[
																0.865,
																-11.95
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																-6.589
															],
															[
																-6.589,
																0
															],
															[
																0,
																0
															],
															[
																0,
																6.589
															],
															[
																6.589,
																0
															]
														],
														"o": [
															[
																-6.589,
																0
															],
															[
																0,
																6.589
															],
															[
																0,
																0
															],
															[
																6.589,
																0
															],
															[
																0,
																-6.589
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-40.866,
																-11.95
															],
															[
																-52.816,
																0
															],
															[
																-40.866,
																11.949
															],
															[
																40.865,
																11.949
															],
															[
																52.815,
																0
															],
															[
																40.865,
																-11.95
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 74.0000030140818
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											306.947,
											89.686
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.922,
									0.329,
									0.141,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 1.6
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "auth0 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.274
										],
										"y": [
											1.006
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p274_1p006_0p333_0"
									],
									"t": 78,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 86.5800035264757
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								689.033,
								337.686,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								341.033,
								89.686,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.117,
											0.117,
											0.667
										],
										"y": [
											1.005,
											1.005,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"0p117_1p005_0p333_0",
										"0p117_1p005_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 78,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 84.1287534266342
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													1.763,
													-1.267
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.64,
													1.945
												]
											],
											"v": [
												[
													2.9,
													3.351
												],
												[
													1.799,
													0
												],
												[
													4.681,
													-2.071
												],
												[
													1.118,
													-2.071
												],
												[
													0.017,
													-5.422
												],
												[
													0.017,
													-5.423
												],
												[
													3.58,
													-5.423
												],
												[
													4.682,
													-2.071
												],
												[
													4.683,
													-2.072
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-2.866,
													3.351
												],
												[
													-2.867,
													3.352
												],
												[
													0.016,
													5.423
												],
												[
													2.9,
													3.351
												],
												[
													0.017,
													1.28
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 2,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-1.673,
													-1.202
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.674,
													2.05
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-4.648,
													-2.072
												],
												[
													-4.648,
													-2.072
												],
												[
													-2.867,
													3.352
												],
												[
													-2.867,
													3.35
												],
												[
													-1.765,
													-0.001
												],
												[
													-4.647,
													-2.071
												],
												[
													-1.085,
													-2.071
												],
												[
													0.016,
													-5.422
												],
												[
													0.017,
													-5.423
												],
												[
													-3.547,
													-5.423
												]
											],
											"c": true
										}
									},
									"nm": "Path 3",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											341.017,
											89.686
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 6,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 5,
					"nm": "COMPANY +",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								612.786,
								337.695,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								-59.964,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "COMPANY +",
										"j": 1,
										"tr": 80,
										"lh": 12,
										"fc": [
											0.92,
											0.33,
											0.14
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 68,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 80.0000032584668
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_1",
			"layers": [
				{
					"ddd": 0,
					"ind": 0,
					"ty": 4,
					"nm": "02_companyb_line\r",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								695.919,
								431.919,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								-139.581,
								-305.581,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											5.339,
											5.339
										]
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.03
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											-139.581,
											-278.831
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0,
														0
													],
													"y": [
														1.001,
														1.001
													]
												},
												"o": {
													"x": [
														0.333,
														0.333
													],
													"y": [
														0,
														0
													]
												},
												"n": [
													"0_1p001_0p333_0",
													"0_1p001_0p333_0"
												],
												"t": 84,
												"s": [
													0,
													0
												],
												"e": [
													100,
													100
												]
											},
											{
												"t": 89.6287536506538
											}
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-139.5,
													-279.5
												],
												[
													-139.5,
													-335
												]
											],
											"c": false
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.03
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 1.033
											}
										},
										{
											"n": "g",
											"nm": "gap",
											"v": {
												"a": 0,
												"k": 3
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.09,
											0.122,
											0.235,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tm",
									"s": {
										"a": 0,
										"k": 0,
										"ix": 1
									},
									"e": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.794
													],
													"y": [
														-0.006
													]
												},
												"n": [
													"0p667_1_0p794_-0p006"
												],
												"t": 86.629,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 93.0000037879676
											}
										],
										"ix": 2
									},
									"o": {
										"a": 0,
										"k": 0,
										"ix": 3
									},
									"m": 2,
									"ix": 4,
									"nm": "Trim Paths 1",
									"mn": "ADBE Vector Filter - Trim"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 4,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 618.000025171656,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "b-circle Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.833
										],
										"y": [
											-0.012
										]
									},
									"n": [
										"0p667_1_0p833_-0p012"
									],
									"t": 90,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 96.0000039101602
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								724.851,
								393.306,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								376.851,
								145.306,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667,
											0.667,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.666,
											0.666,
											0.333
										],
										"y": [
											-0.015,
											-0.015,
											0.333
										]
									},
									"n": [
										"0p667_1_0p666_-0p015",
										"0p667_1_0p666_-0p015",
										"0p667_0p667_0p333_0p333"
									],
									"t": 87,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 96.0000039101602
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0,
													"y": 1
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"n": "0_1_0p333_0",
												"t": 94,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																-5.953
															],
															[
																-5.953,
																0
															],
															[
																0,
																0
															],
															[
																0,
																5.953
															],
															[
																5.954,
																0
															]
														],
														"o": [
															[
																-5.953,
																0
															],
															[
																0,
																5.953
															],
															[
																0,
																0
															],
															[
																5.954,
																0
															],
															[
																0,
																-5.953
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-28.917,
																-10.797
															],
															[
																-39.714,
																-0.001
															],
															[
																-28.917,
																10.796
															],
															[
																-28.958,
																10.796
															],
															[
																-18.163,
																-0.001
															],
															[
																-28.958,
																-10.797
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																-5.953
															],
															[
																-5.953,
																0
															],
															[
																0,
																0
															],
															[
																0,
																5.953
															],
															[
																5.954,
																0
															]
														],
														"o": [
															[
																-5.953,
																0
															],
															[
																0,
																5.953
															],
															[
																0,
																0
															],
															[
																5.954,
																0
															],
															[
																0,
																-5.953
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-41.042,
																-10.797
															],
															[
																-51.839,
																-0.001
															],
															[
																-41.042,
																10.796
															],
															[
																41.042,
																10.796
															],
															[
																51.837,
																-0.001
															],
															[
																41.042,
																-10.797
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 104.000004236007
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.6
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											376.852,
											145.306
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 4,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 5,
					"nm": "COMPETITOR B",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								682.288,
								392.695,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								-39.962,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "COMPETITOR B",
										"j": 2,
										"tr": 80,
										"lh": 12,
										"fc": [
											0.05,
											0.07,
											0.19
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 104,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 116.000004724777
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_2",
			"layers": [
				{
					"ddd": 0,
					"ind": 0,
					"ty": 5,
					"nm": "\rCompetitor A",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								533.288,
								427.195,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								-39.962,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "COMPETITOR A",
										"j": 2,
										"tr": 80,
										"lh": 12,
										"fc": [
											0.05,
											0.07,
											0.19
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 58,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 70.0000028511585
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "\rcompetitor a - circle",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.833
										],
										"y": [
											-0.012
										]
									},
									"n": [
										"0p667_1_0p833_-0p012"
									],
									"t": 44,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 50.0000020365418
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								613.851,
								426.806,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								413.945,
								145.306,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667,
											0.667,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.666,
											0.666,
											0.333
										],
										"y": [
											-0.015,
											-0.015,
											0.333
										]
									},
									"n": [
										"0p667_1_0p666_-0p015",
										"0p667_1_0p666_-0p015",
										"0p667_0p667_0p333_0p333"
									],
									"t": 41,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 50.0000020365418
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0,
													"y": 1
												},
												"o": {
													"x": 0.167,
													"y": 0
												},
												"n": "0_1_0p167_0",
												"t": 48,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																-5.953
															],
															[
																-5.953,
																0
															],
															[
																0,
																0
															],
															[
																0,
																5.953
															],
															[
																5.954,
																0
															]
														],
														"o": [
															[
																-5.953,
																0
															],
															[
																0,
																5.953
															],
															[
																0,
																0
															],
															[
																5.954,
																0
															],
															[
																0,
																-5.953
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																36.236,
																-10.797
															],
															[
																25.44,
																-0.001
															],
															[
																36.236,
																10.796
															],
															[
																37.95,
																10.796
															],
															[
																48.746,
																-0.001
															],
															[
																37.95,
																-10.797
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																-5.953
															],
															[
																-5.953,
																0
															],
															[
																0,
																0
															],
															[
																0,
																5.953
															],
															[
																5.954,
																0
															]
														],
														"o": [
															[
																-5.953,
																0
															],
															[
																0,
																5.953
															],
															[
																0,
																0
															],
															[
																5.954,
																0
															],
															[
																0,
																-5.953
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-41.042,
																-10.797
															],
															[
																-51.839,
																-0.001
															],
															[
																-41.042,
																10.796
															],
															[
																41.042,
																10.796
															],
															[
																51.837,
																-0.001
															],
															[
																41.042,
																-10.797
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 58.0000023623884
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.6
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											376.852,
											145.306
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 4,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "\rcompetitor a - line",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								612.419,
								481.919,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								-139.581,
								-305.581,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											5.339,
											5.339
										]
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.03
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											-139.581,
											-278.831
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0,
														0
													],
													"y": [
														1.001,
														1.001
													]
												},
												"o": {
													"x": [
														0.333,
														0.333
													],
													"y": [
														0,
														0
													]
												},
												"n": [
													"0_1p001_0p333_0",
													"0_1p001_0p333_0"
												],
												"t": 38,
												"s": [
													0,
													0
												],
												"e": [
													100,
													100
												]
											},
											{
												"t": 43.6287517770354
											}
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-139.5,
													-279.5
												],
												[
													-139.5,
													-349.5
												]
											],
											"c": false
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.03
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 1.033
											}
										},
										{
											"n": "g",
											"nm": "gap",
											"v": {
												"a": 0,
												"k": 3
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.09,
											0.122,
											0.235,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tm",
									"s": {
										"a": 0,
										"k": 0,
										"ix": 1
									},
									"e": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.794
													],
													"y": [
														-0.006
													]
												},
												"n": [
													"0p667_1_0p794_-0p006"
												],
												"t": 40.629,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 47.0000019143492
											}
										],
										"ix": 2
									},
									"o": {
										"a": 0,
										"k": 0,
										"ix": 3
									},
									"m": 2,
									"ix": 4,
									"nm": "Trim Paths 1",
									"mn": "ADBE Vector Filter - Trim"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 4,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 640.000026067734,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_3",
			"layers": [
				{
					"ddd": 0,
					"ind": 0,
					"ty": 5,
					"nm": "\r7_text",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p667_1_0p333_0"
									],
									"t": 160,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 174.000007087165
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								820.172,
								627.445,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								34.422,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "COMPLIANCE",
										"j": 0,
										"tr": 100,
										"lh": 12,
										"fc": [
											0.33,
											0.34,
											0.4
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 133,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 149.000006068894
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "\r7_ok",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"1_1_0p333_0"
									],
									"t": 130,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 137,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 160,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 174.000007087165
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								769.146,
								627.702,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								421.146,
								230.952,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1,
											1,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"1_1_0p333_0",
										"1_1_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 127,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 134.000005457932
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.198,
													0.011
												],
												[
													0.138,
													0.138
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.194,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.138,
													0.142
												]
											],
											"v": [
												[
													-0.973,
													2.938
												],
												[
													-1.492,
													2.723
												],
												[
													-4.082,
													0.132
												],
												[
													-3.045,
													-0.905
												],
												[
													-0.979,
													1.162
												],
												[
													3.032,
													-2.949
												],
												[
													4.082,
													-1.925
												],
												[
													-0.448,
													2.716
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.041,
											230.49
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.423,
													6.307
												],
												[
													6.424,
													6.307
												],
												[
													6.424,
													-6.306
												],
												[
													-6.423,
													-6.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												],
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												],
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												]
											],
											"v": [
												[
													7.158,
													7.773
												],
												[
													-7.156,
													7.773
												],
												[
													-7.89,
													7.04
												],
												[
													-7.89,
													-7.04
												],
												[
													-7.156,
													-7.773
												],
												[
													7.158,
													-7.773
												],
												[
													7.891,
													-7.04
												],
												[
													7.891,
													7.04
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.146,
											230.952
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 5,
					"nm": "\r6_text",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p667_1_0p333_0"
									],
									"t": 133,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 149.000006068894
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								834.281,
								602.445,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								48.531,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "CERTIFICATIONS",
										"j": 0,
										"tr": 100,
										"lh": 12,
										"fc": [
											0.33,
											0.34,
											0.4
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 112,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 127.000005172816
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "\r6_ok",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"1_1_0p333_0"
									],
									"t": 108,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 115,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 133,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 149.000006068894
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								769.146,
								603.202,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								421.146,
								230.952,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1,
											1,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"1_1_0p333_0",
										"1_1_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 105,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 112.000004561854
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.198,
													0.011
												],
												[
													0.138,
													0.138
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.194,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.138,
													0.142
												]
											],
											"v": [
												[
													-0.973,
													2.938
												],
												[
													-1.492,
													2.723
												],
												[
													-4.082,
													0.132
												],
												[
													-3.045,
													-0.905
												],
												[
													-0.979,
													1.162
												],
												[
													3.032,
													-2.949
												],
												[
													4.082,
													-1.925
												],
												[
													-0.448,
													2.716
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.041,
											230.49
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.423,
													6.307
												],
												[
													6.424,
													6.307
												],
												[
													6.424,
													-6.306
												],
												[
													-6.423,
													-6.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												],
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												],
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												]
											],
											"v": [
												[
													7.158,
													7.773
												],
												[
													-7.156,
													7.773
												],
												[
													-7.89,
													7.04
												],
												[
													-7.89,
													-7.04
												],
												[
													-7.156,
													-7.773
												],
												[
													7.158,
													-7.773
												],
												[
													7.891,
													-7.04
												],
												[
													7.891,
													7.04
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.146,
											230.952
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 5,
					"nm": "\r5_text",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p667_1_0p333_0"
									],
									"t": 112,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 127.000005172816
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								848.327,
								578.945,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								62.577,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "REDUCE SALES CYCLE",
										"j": 0,
										"tr": 100,
										"lh": 12,
										"fc": [
											0.33,
											0.34,
											0.4
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 90,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 105.000004276738
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 5,
					"ty": 4,
					"nm": "\r5_ok",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"1_1_0p333_0"
									],
									"t": 86,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 93,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 112,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 127.000005172816
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								769.146,
								578.202,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								421.146,
								230.952,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1,
											1,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"1_1_0p333_0",
										"1_1_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 83,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 90.0000036657751
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.198,
													0.011
												],
												[
													0.138,
													0.138
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.194,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.138,
													0.142
												]
											],
											"v": [
												[
													-0.973,
													2.938
												],
												[
													-1.492,
													2.723
												],
												[
													-4.082,
													0.132
												],
												[
													-3.045,
													-0.905
												],
												[
													-0.979,
													1.162
												],
												[
													3.032,
													-2.949
												],
												[
													4.082,
													-1.925
												],
												[
													-0.448,
													2.716
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.041,
											230.49
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.423,
													6.307
												],
												[
													6.424,
													6.307
												],
												[
													6.424,
													-6.306
												],
												[
													-6.423,
													-6.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												],
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												],
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												]
											],
											"v": [
												[
													7.158,
													7.773
												],
												[
													-7.156,
													7.773
												],
												[
													-7.89,
													7.04
												],
												[
													-7.89,
													-7.04
												],
												[
													-7.156,
													-7.773
												],
												[
													7.158,
													-7.773
												],
												[
													7.891,
													-7.04
												],
												[
													7.891,
													7.04
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.146,
											230.952
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 6,
					"ty": 5,
					"nm": "\r4_text",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p667_1_0p333_0"
									],
									"t": 90,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 105.000004276738
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								831.074,
								553.943,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								45.324,
								-3.557,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "MINIMIZE RISK",
										"j": 0,
										"tr": 100,
										"lh": 12,
										"fc": [
											0.33,
											0.34,
											0.4
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 69,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 83.0000033806593
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 7,
					"ty": 4,
					"nm": "\r4_ok",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"1_1_0p333_0"
									],
									"t": 65,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 72,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 90,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 105.000004276738
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								769.146,
								553.202,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								421.146,
								230.952,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1,
											1,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"1_1_0p333_0",
										"1_1_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 62,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 69.0000028104276
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.198,
													0.011
												],
												[
													0.138,
													0.138
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.194,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.138,
													0.142
												]
											],
											"v": [
												[
													-0.973,
													2.938
												],
												[
													-1.492,
													2.723
												],
												[
													-4.082,
													0.132
												],
												[
													-3.045,
													-0.905
												],
												[
													-0.979,
													1.162
												],
												[
													3.032,
													-2.949
												],
												[
													4.082,
													-1.925
												],
												[
													-0.448,
													2.716
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.041,
											230.49
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.423,
													6.307
												],
												[
													6.424,
													6.307
												],
												[
													6.424,
													-6.306
												],
												[
													-6.423,
													-6.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												],
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												],
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												]
											],
											"v": [
												[
													7.158,
													7.773
												],
												[
													-7.156,
													7.773
												],
												[
													-7.89,
													7.04
												],
												[
													-7.89,
													-7.04
												],
												[
													-7.156,
													-7.773
												],
												[
													7.158,
													-7.773
												],
												[
													7.891,
													-7.04
												],
												[
													7.891,
													7.04
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.146,
											230.952
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 8,
					"ty": 5,
					"nm": "\r3_text",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p667_1_0p333_0"
									],
									"t": 69,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 83.0000033806593
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								841.395,
								528.945,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								55.645,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "INCREASE REVENUE",
										"j": 0,
										"tr": 100,
										"lh": 12,
										"fc": [
											0.33,
											0.34,
											0.4
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 48,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 62.0000025253118
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 9,
					"ty": 4,
					"nm": "\r3_ok",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"1_1_0p333_0"
									],
									"t": 44,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 51,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 69,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 83.0000033806593
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								769.146,
								528.702,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								421.146,
								230.952,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1,
											1,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"1_1_0p333_0",
										"1_1_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 41,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 48.0000019550801
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.198,
													0.011
												],
												[
													0.138,
													0.138
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.194,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.138,
													0.142
												]
											],
											"v": [
												[
													-0.973,
													2.938
												],
												[
													-1.492,
													2.723
												],
												[
													-4.082,
													0.132
												],
												[
													-3.045,
													-0.905
												],
												[
													-0.979,
													1.162
												],
												[
													3.032,
													-2.949
												],
												[
													4.082,
													-1.925
												],
												[
													-0.448,
													2.716
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.041,
											230.49
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.423,
													6.307
												],
												[
													6.424,
													6.307
												],
												[
													6.424,
													-6.306
												],
												[
													-6.423,
													-6.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												],
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												],
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												]
											],
											"v": [
												[
													7.158,
													7.773
												],
												[
													-7.156,
													7.773
												],
												[
													-7.89,
													7.04
												],
												[
													-7.89,
													-7.04
												],
												[
													-7.156,
													-7.773
												],
												[
													7.158,
													-7.773
												],
												[
													7.891,
													-7.04
												],
												[
													7.891,
													7.04
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.146,
											230.952
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 10,
					"ty": 5,
					"nm": "\r2_text",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p667_1_0p333_0"
									],
									"t": 51,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 62.0000025253118
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								834.167,
								503.945,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								48.417,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "SINGLE SIGN ON",
										"j": 0,
										"tr": 100,
										"lh": 12,
										"fc": [
											0.33,
											0.34,
											0.4
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"k": 0
									},
									"ne": {
										"k": 0
									},
									"a": {
										"k": 100
									},
									"b": 0,
									"sh": 0,
									"s": {
										"k": 0
									},
									"e": {
										"k": 100
									},
									"o": {
										"k": 0
									}
								},
								"a": {}
							},
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														0.994
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_0p994_0p333_0"
												],
												"t": 30,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 39.0000015885026
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 11,
					"ty": 4,
					"nm": "\r2_ok",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"1_1_0p333_0"
									],
									"t": 23,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 30,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 51,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 62.0000025253118
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								769.146,
								503.702,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								421.146,
								230.952,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1,
											1,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"1_1_0p333_0",
										"1_1_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 20,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 27.0000010997325
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.198,
													0.011
												],
												[
													0.138,
													0.138
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.194,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.138,
													0.142
												]
											],
											"v": [
												[
													-0.973,
													2.938
												],
												[
													-1.492,
													2.723
												],
												[
													-4.082,
													0.132
												],
												[
													-3.045,
													-0.905
												],
												[
													-0.979,
													1.162
												],
												[
													3.032,
													-2.949
												],
												[
													4.082,
													-1.925
												],
												[
													-0.448,
													2.716
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.041,
											230.49
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.423,
													6.307
												],
												[
													6.424,
													6.307
												],
												[
													6.424,
													-6.306
												],
												[
													-6.423,
													-6.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												],
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												],
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												]
											],
											"v": [
												[
													7.158,
													7.773
												],
												[
													-7.156,
													7.773
												],
												[
													-7.89,
													7.04
												],
												[
													-7.89,
													-7.04
												],
												[
													-7.156,
													-7.773
												],
												[
													7.158,
													-7.773
												],
												[
													7.891,
													-7.04
												],
												[
													7.891,
													7.04
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.146,
											230.952
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 12,
					"ty": 5,
					"nm": "1_text\r",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p667_1_0p333_0"
									],
									"t": 33,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 40.0000016292334
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								786.243,
								478.945,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0.493,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "SECURITY",
										"j": 0,
										"tr": 100,
										"lh": 12,
										"fc": [
											0.33,
											0.34,
											0.4
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.169
													],
													"y": [
														0.992
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p169_0p992_0p333_0"
												],
												"t": 12,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 22.0000008960784
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 13,
					"ty": 4,
					"nm": "\r1_ok",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"1_1_0p333_0"
									],
									"t": 8,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0.333
										]
									},
									"n": [
										"0p833_0p833_0p333_0p333"
									],
									"t": 15,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 33,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 40.0000016292334
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								769.146,
								478.952,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								421.146,
								230.952,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1,
											1,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"1_1_0p333_0",
										"1_1_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 5,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 12.00000048877
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.198,
													0.011
												],
												[
													0.138,
													0.138
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.194,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.138,
													0.142
												]
											],
											"v": [
												[
													-0.973,
													2.938
												],
												[
													-1.492,
													2.723
												],
												[
													-4.082,
													0.132
												],
												[
													-3.045,
													-0.905
												],
												[
													-0.979,
													1.162
												],
												[
													3.032,
													-2.949
												],
												[
													4.082,
													-1.925
												],
												[
													-0.448,
													2.716
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.041,
											230.49
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.423,
													6.307
												],
												[
													6.424,
													6.307
												],
												[
													6.424,
													-6.306
												],
												[
													-6.423,
													-6.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												],
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												],
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												]
											],
											"v": [
												[
													7.158,
													7.773
												],
												[
													-7.156,
													7.773
												],
												[
													-7.89,
													7.04
												],
												[
													-7.89,
													-7.04
												],
												[
													-7.156,
													-7.773
												],
												[
													7.158,
													-7.773
												],
												[
													7.891,
													-7.04
												],
												[
													7.891,
													7.04
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.146,
											230.952
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_4",
			"layers": [
				{
					"ddd": 0,
					"ind": 0,
					"ty": 4,
					"nm": "1 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0
										],
										"y": [
											0.99
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0_0p99_0p333_0"
									],
									"t": 20,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0
										],
										"y": [
											0
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0_0_0p167_0p167"
									],
									"t": 24,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 27,
									"s": [
										100
									],
									"e": [
										0
									]
								},
								{
									"i": {
										"x": [
											0
										],
										"y": [
											0.995
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0_0p995_0p333_0"
									],
									"t": 29,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 31,
									"s": [
										100
									],
									"e": [
										0
									]
								},
								{
									"i": {
										"x": [
											0
										],
										"y": [
											0.995
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0_0p995_0p333_0"
									],
									"t": 33,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 35.0000014255792
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.03,
										"y": 0.957
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"n": "0p03_0p957_0p333_0",
									"t": 45,
									"s": [
										655.67,
										559.457,
										0
									],
									"e": [
										655.67,
										484.933,
										0
									],
									"to": [
										0.00002379644502,
										-12.4206972122192,
										0
									],
									"ti": [
										-0.00002379644502,
										12.4206972122192,
										0
									]
								},
								{
									"t": 58.0000023623884
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.67,
								236.933,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"ef": [
						{
							"ty": 5,
							"nm": "Opacity - Overshoot",
							"mn": "ADBE Slider Control",
							"ix": 1,
							"en": 1,
							"ef": [
								{
									"ty": 0,
									"nm": "Slider",
									"mn": "ADBE Slider Control-0001",
									"ix": 1,
									"v": {
										"a": 0,
										"k": 20,
										"x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
									}
								}
							]
						},
						{
							"ty": 5,
							"nm": "Opacity - Bounce",
							"mn": "ADBE Slider Control",
							"ix": 2,
							"en": 1,
							"ef": [
								{
									"ty": 0,
									"nm": "Slider",
									"mn": "ADBE Slider Control-0001",
									"ix": 1,
									"v": {
										"a": 0,
										"k": 40,
										"x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
									}
								}
							]
						},
						{
							"ty": 5,
							"nm": "Opacity - Friction",
							"mn": "ADBE Slider Control",
							"ix": 3,
							"en": 1,
							"ef": [
								{
									"ty": 0,
									"nm": "Slider",
									"mn": "ADBE Slider Control-0001",
									"ix": 1,
									"v": {
										"a": 0,
										"k": 40,
										"x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
									}
								}
							]
						}
					],
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-85.233,
													-0.456
												],
												[
													0,
													49.693
												],
												[
													85.234,
													-0.456
												],
												[
													0,
													-49.665
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.127,
													0
												],
												[
													0.113,
													0.067
												],
												[
													0,
													0
												],
												[
													-0.002,
													0.257
												],
												[
													-0.223,
													0.129
												],
												[
													0,
													0
												],
												[
													-0.224,
													-0.129
												],
												[
													0,
													0
												],
												[
													-0.001,
													-0.257
												],
												[
													0.222,
													-0.131
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.127,
													0
												],
												[
													0,
													0
												],
												[
													-0.222,
													-0.131
												],
												[
													0.001,
													-0.257
												],
												[
													0,
													0
												],
												[
													0.224,
													-0.129
												],
												[
													0,
													0
												],
												[
													0.222,
													0.129
												],
												[
													0.001,
													0.257
												],
												[
													0,
													0
												],
												[
													-0.113,
													0.067
												]
											],
											"v": [
												[
													0,
													51.255
												],
												[
													-0.366,
													51.155
												],
												[
													-87.035,
													0.161
												],
												[
													-87.391,
													-0.465
												],
												[
													-87.03,
													-1.088
												],
												[
													-0.361,
													-51.126
												],
												[
													0.362,
													-51.126
												],
												[
													87.031,
													-1.088
												],
												[
													87.392,
													-0.465
												],
												[
													87.036,
													0.161
												],
												[
													0.367,
													51.155
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											307.67,
											236.917
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "2 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.015
										],
										"y": [
											1.023
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p015_1p023_0p333_0"
									],
									"t": 45,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 52.0000021180034
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.211,
										"y": 1
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"n": "0p211_1_0p333_0",
									"t": 45,
									"s": [
										655.67,
										559.457,
										0
									],
									"e": [
										655.67,
										506.833,
										0
									],
									"to": [
										-0.00002515883716,
										-8.77060222625732,
										0
									],
									"ti": [
										0.00002515883716,
										8.77060222625732,
										0
									]
								},
								{
									"t": 55.0000022401959
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.67,
								258.833,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-80.449,
													-0.436
												],
												[
													0,
													46.899
												],
												[
													80.451,
													-0.436
												],
												[
													0,
													-46.884
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.064,
													0
												],
												[
													0.056,
													0.034
												],
												[
													0,
													0
												],
												[
													-0.001,
													0.129
												],
												[
													-0.112,
													0.064
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.064
												],
												[
													0,
													0
												],
												[
													0,
													-0.128
												],
												[
													0.111,
													-0.066
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.063,
													0
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.066
												],
												[
													0,
													-0.128
												],
												[
													0,
													0
												],
												[
													0.111,
													-0.064
												],
												[
													0,
													0
												],
												[
													0.112,
													0.064
												],
												[
													0,
													0.129
												],
												[
													0,
													0
												],
												[
													-0.056,
													0.034
												]
											],
											"v": [
												[
													0,
													47.679
												],
												[
													-0.182,
													47.629
												],
												[
													-81.35,
													-0.127
												],
												[
													-81.529,
													-0.441
												],
												[
													-81.348,
													-0.752
												],
												[
													-0.18,
													-47.615
												],
												[
													0.182,
													-47.615
												],
												[
													81.349,
													-0.752
												],
												[
													81.53,
													-0.441
												],
												[
													81.352,
													-0.127
												],
												[
													0.184,
													47.629
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.757,
											0.765,
											0.788,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											307.669,
											258.825
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "3 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.197
										],
										"y": [
											0.993
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p197_0p993_0p333_0"
									],
									"t": 45,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 52.0000021180034
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.338,
										"y": 0.972
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"n": "0p338_0p972_0p333_0",
									"t": 45,
									"s": [
										655.67,
										559.457,
										0
									],
									"e": [
										655.67,
										529.356,
										0
									],
									"to": [
										0.00000535874142,
										-5.01690244674683,
										0
									],
									"ti": [
										-0.00000535874142,
										5.01690244674683,
										0
									]
								},
								{
									"t": 55.0000022401959
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.67,
								281.356,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-74.812,
													-0.406
												],
												[
													0,
													43.613
												],
												[
													74.812,
													-0.406
												],
												[
													0,
													-43.599
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.064,
													0
												],
												[
													0.057,
													0.033
												],
												[
													0,
													0
												],
												[
													-0.001,
													0.129
												],
												[
													-0.112,
													0.064
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.064
												],
												[
													0,
													0
												],
												[
													-0.001,
													-0.128
												],
												[
													0.111,
													-0.066
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.063,
													0
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.066
												],
												[
													0,
													-0.128
												],
												[
													0,
													0
												],
												[
													0.111,
													-0.064
												],
												[
													0,
													0
												],
												[
													0.111,
													0.064
												],
												[
													0,
													0.129
												],
												[
													0,
													0
												],
												[
													-0.057,
													0.033
												]
											],
											"v": [
												[
													0,
													44.393
												],
												[
													-0.183,
													44.344
												],
												[
													-75.713,
													-0.096
												],
												[
													-75.891,
													-0.411
												],
												[
													-75.71,
													-0.721
												],
												[
													-0.18,
													-44.329
												],
												[
													0.181,
													-44.329
												],
												[
													75.711,
													-0.721
												],
												[
													75.892,
													-0.411
												],
												[
													75.713,
													-0.096
												],
												[
													0.184,
													44.344
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.757,
											0.765,
											0.788,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											307.67,
											281.348
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "4 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.182
										],
										"y": [
											1.003
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p182_1p003_0p333_0"
									],
									"t": 45,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 52.0000021180034
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.327,
										"y": 1
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"n": "0p327_1_0p333_0",
									"t": 45,
									"s": [
										655.67,
										559.457,
										0
									],
									"e": [
										655.67,
										551.185,
										0
									],
									"to": [
										0.00004223414726,
										-1.37864756584167,
										0
									],
									"ti": [
										-0.00004223414726,
										1.37864756584167,
										0
									]
								},
								{
									"t": 55.0000022401959
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.67,
								303.185,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-69.362,
													-0.376
												],
												[
													0,
													40.436
												],
												[
													69.363,
													-0.376
												],
												[
													0,
													-40.422
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.064,
													0
												],
												[
													0.056,
													0.033
												],
												[
													0,
													0
												],
												[
													-0.001,
													0.129
												],
												[
													-0.112,
													0.064
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.065
												],
												[
													0,
													0
												],
												[
													-0.001,
													-0.128
												],
												[
													0.111,
													-0.066
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.063,
													0
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.066
												],
												[
													0,
													-0.128
												],
												[
													0,
													0
												],
												[
													0.111,
													-0.065
												],
												[
													0,
													0
												],
												[
													0.111,
													0.064
												],
												[
													0,
													0.129
												],
												[
													0,
													0
												],
												[
													-0.056,
													0.033
												]
											],
											"v": [
												[
													0,
													41.216
												],
												[
													-0.183,
													41.167
												],
												[
													-70.263,
													-0.067
												],
												[
													-70.441,
													-0.38
												],
												[
													-70.26,
													-0.692
												],
												[
													-0.18,
													-41.152
												],
												[
													0.181,
													-41.152
												],
												[
													70.261,
													-0.692
												],
												[
													70.442,
													-0.38
												],
												[
													70.263,
													-0.067
												],
												[
													0.183,
													41.167
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.757,
											0.765,
											0.788,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											307.67,
											303.177
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "5 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0
										],
										"y": [
											1.021
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0_1p021_0p333_0"
									],
									"t": 45,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 52.0000021180034
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.2,
										"y": 1
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"n": "0p2_1_0p333_0",
									"t": 45,
									"s": [
										655.67,
										559.457,
										0
									],
									"e": [
										655.67,
										573.691,
										0
									],
									"to": [
										-0.0000099000481,
										2.37226295471191,
										0
									],
									"ti": [
										0.0000099000481,
										-2.37226295471191,
										0
									]
								},
								{
									"t": 55.0000022401959
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.67,
								325.691,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-63.784,
													-0.344
												],
												[
													0,
													37.185
												],
												[
													63.785,
													-0.344
												],
												[
													0,
													-37.171
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.064,
													0
												],
												[
													0.056,
													0.033
												],
												[
													0,
													0
												],
												[
													-0.001,
													0.129
												],
												[
													-0.112,
													0.064
												],
												[
													0,
													0
												],
												[
													-0.112,
													-0.064
												],
												[
													0,
													0
												],
												[
													-0.001,
													-0.128
												],
												[
													0.111,
													-0.066
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.063,
													0
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.066
												],
												[
													0,
													-0.128
												],
												[
													0,
													0
												],
												[
													0.112,
													-0.064
												],
												[
													0,
													0
												],
												[
													0.112,
													0.064
												],
												[
													0,
													0.129
												],
												[
													0,
													0
												],
												[
													-0.056,
													0.033
												]
											],
											"v": [
												[
													0,
													37.966
												],
												[
													-0.182,
													37.916
												],
												[
													-64.685,
													-0.035
												],
												[
													-64.863,
													-0.349
												],
												[
													-64.682,
													-0.66
												],
												[
													-0.181,
													-37.902
												],
												[
													0.181,
													-37.902
												],
												[
													64.684,
													-0.66
												],
												[
													64.865,
													-0.349
												],
												[
													64.686,
													-0.035
												],
												[
													0.184,
													37.916
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.757,
											0.765,
											0.788,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											307.67,
											325.683
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 5,
					"ty": 4,
					"nm": "6 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0
										],
										"y": [
											1.021
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0_1p021_0p333_0"
									],
									"t": 45,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 52.0000021180034
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.2,
										"y": 1
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"n": "0p2_1_0p333_0",
									"t": 45,
									"s": [
										655.67,
										559.457,
										0
									],
									"e": [
										655.67,
										595.96,
										0
									],
									"to": [
										-0.00004232497304,
										6.08375215530396,
										0
									],
									"ti": [
										0.00004232497304,
										-6.08375215530396,
										0
									]
								},
								{
									"t": 55.0000022401959
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.67,
								347.96,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-58.194,
													-0.313
												],
												[
													0,
													33.927
												],
												[
													58.194,
													-0.313
												],
												[
													0,
													-33.913
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.063,
													0
												],
												[
													0.056,
													0.033
												],
												[
													0,
													0
												],
												[
													-0.001,
													0.129
												],
												[
													-0.112,
													0.064
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.065
												],
												[
													0,
													0
												],
												[
													0,
													-0.128
												],
												[
													0.111,
													-0.066
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.064,
													0
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.066
												],
												[
													0,
													-0.128
												],
												[
													0,
													0
												],
												[
													0.111,
													-0.065
												],
												[
													0,
													0
												],
												[
													0.111,
													0.064
												],
												[
													0.001,
													0.129
												],
												[
													0,
													0
												],
												[
													-0.056,
													0.033
												]
											],
											"v": [
												[
													0,
													34.708
												],
												[
													-0.182,
													34.658
												],
												[
													-59.095,
													-0.004
												],
												[
													-59.273,
													-0.318
												],
												[
													-59.092,
													-0.629
												],
												[
													-0.181,
													-34.643
												],
												[
													0.181,
													-34.643
												],
												[
													59.094,
													-0.629
												],
												[
													59.273,
													-0.318
												],
												[
													59.095,
													-0.004
												],
												[
													0.184,
													34.658
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.757,
											0.765,
											0.788,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											307.67,
											347.951
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 6,
					"ty": 4,
					"nm": "7 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0_1_0p333_0"
									],
									"t": 45,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 52.0000021180034
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.158,
										"y": 1
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"n": "0p158_1_0p333_0",
									"t": 45,
									"s": [
										655.67,
										559.457,
										0
									],
									"e": [
										655.67,
										617.742,
										0
									],
									"to": [
										0.00000599452414,
										9.71416759490967,
										0
									],
									"ti": [
										-0.00000599452414,
										-9.71416759490967,
										0
									]
								},
								{
									"t": 58.0000023623884
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.67,
								369.742,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-52.561,
													-0.275
												],
												[
													0,
													30.65
												],
												[
													52.56,
													-0.275
												],
												[
													0,
													-30.621
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.126,
													0
												],
												[
													0.113,
													0.066
												],
												[
													0,
													0
												],
												[
													-0.001,
													0.257
												],
												[
													-0.223,
													0.129
												],
												[
													0,
													0
												],
												[
													-0.224,
													-0.129
												],
												[
													0,
													0
												],
												[
													-0.002,
													-0.257
												],
												[
													0.222,
													-0.131
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.127,
													0
												],
												[
													0,
													0
												],
												[
													-0.222,
													-0.131
												],
												[
													0.002,
													-0.257
												],
												[
													0,
													0
												],
												[
													0.224,
													-0.129
												],
												[
													0,
													0
												],
												[
													0.223,
													0.129
												],
												[
													0.001,
													0.257
												],
												[
													0,
													0
												],
												[
													-0.113,
													0.066
												]
											],
											"v": [
												[
													0,
													32.211
												],
												[
													-0.367,
													32.112
												],
												[
													-54.363,
													0.342
												],
												[
													-54.72,
													-0.284
												],
												[
													-54.358,
													-0.907
												],
												[
													-0.362,
													-32.082
												],
												[
													0.361,
													-32.082
												],
												[
													54.357,
													-0.907
												],
												[
													54.719,
													-0.284
												],
												[
													54.362,
													0.342
												],
												[
													0.366,
													32.112
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											307.67,
											369.726
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		}
	],
	"fonts": {
		"list": [
			{
				"fName": "RobotoMono-Medium",
				"fFamily": "Roboto Mono",
				"fStyle": "Medium",
				"ascent": 75
			}
		]
	},
	"layers": [
		{
			"ddd": 0,
			"ind": 0,
			"ty": 0,
			"nm": "3_auth0",
			"refId": "comp_0",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						247,
						224,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						720,
						512,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"w": 1440,
			"h": 1024,
			"ip": 66.0000026882351,
			"op": 1566.00006378449,
			"st": 66.0000026882351,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 1,
			"ty": 0,
			"nm": "2_companyb",
			"refId": "comp_1",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						247,
						224,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						720,
						512,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"w": 1440,
			"h": 1024,
			"ip": -6.00000024438501,
			"op": 1494.00006085187,
			"st": -6.00000024438501,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 0,
			"nm": "1_companyA",
			"refId": "comp_2",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						247,
						224,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						720,
						512,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"w": 1440,
			"h": 1024,
			"ip": 15.0000006109625,
			"op": 1515.00006170722,
			"st": 15.0000006109625,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 0,
			"nm": "Texto derecha",
			"refId": "comp_3",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						247,
						224,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						720,
						512,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"w": 1440,
			"h": 1024,
			"ip": 155.000006313279,
			"op": 1655.00006740953,
			"st": 155.000006313279,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 0,
			"nm": "Graph",
			"refId": "comp_4",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						247,
						224,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						720,
						512,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"w": 1440,
			"h": 1024,
			"ip": 0,
			"op": 1500.00006109625,
			"st": 0,
			"bm": 0,
			"sr": 1
		}
	],
	"chars": [
		{
			"ch": "S",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												43.864,
												-15.357
											],
											[
												41.666,
												-11.89
											],
											[
												38.053,
												-9.603
											],
											[
												33.35,
												-8.545
											],
											[
												27.547,
												-8.814
											],
											[
												22.542,
												-10.685
											],
											[
												18.896,
												-14.128
											],
											[
												16.862,
												-19.19
											],
											[
												4.932,
												-21.338
											],
											[
												5.339,
												-16.658
											],
											[
												7.755,
												-10.749
											],
											[
												11.735,
												-6.014
											],
											[
												16.951,
												-2.457
											],
											[
												22.95,
												-0.13
											],
											[
												29.411,
												0.928
											],
											[
												37.907,
												0.513
											],
											[
												46.436,
												-2.376
											],
											[
												52.718,
												-7.65
											],
											[
												56.055,
												-15.25
											],
											[
												55.452,
												-24.185
											],
											[
												51.416,
												-31.03
											],
											[
												44.938,
												-36.19
											],
											[
												36.702,
												-39.844
											],
											[
												29.972,
												-41.886
											],
											[
												24.853,
												-44.01
											],
											[
												21.012,
												-46.899
											],
											[
												18.896,
												-50.781
											],
											[
												19.205,
												-55.404
											],
											[
												21.297,
												-58.935
											],
											[
												24.772,
												-61.36
											],
											[
												29.394,
												-62.5
											],
											[
												35.01,
												-62.207
											],
											[
												39.461,
												-60.205
											],
											[
												42.488,
												-56.779
											],
											[
												44.075,
												-52.181
											],
											[
												55.957,
												-50.391
											],
											[
												55.257,
												-56.55
											],
											[
												50.886,
												-64.136
											],
											[
												43.824,
												-69.425
											],
											[
												34.668,
												-72.07
											],
											[
												25,
												-71.614
											],
											[
												16.568,
												-68.489
											],
											[
												10.376,
												-63.045
											],
											[
												7.08,
												-55.452
											],
											[
												7.74,
												-46.639
											],
											[
												12.101,
												-39.949
											],
											[
												18.791,
												-34.993
											],
											[
												26.985,
												-31.575
											],
											[
												33.796,
												-29.467
											],
											[
												38.875,
												-27.149
											],
											[
												42.44,
												-24.064
											],
											[
												44.189,
												-20.003
											]
										],
										"o": [
											[
												42.561,
												-12.915
											],
											[
												39.387,
												-10.23
											],
											[
												34.993,
												-8.757
											],
											[
												29.476,
												-8.545
											],
											[
												24.064,
												-9.888
											],
											[
												19.938,
												-12.8
											],
											[
												17.334,
												-17.318
											],
											[
												16.699,
												-21.338
											],
											[
												4.964,
												-18.897
											],
											[
												6.771,
												-12.589
											],
											[
												10.262,
												-7.462
											],
											[
												15.12,
												-3.507
											],
											[
												20.89,
												-0.764
											],
											[
												27.246,
												0.716
											],
											[
												34.815,
												0.928
											],
											[
												43.831,
												-1.147
											],
											[
												50.928,
												-5.631
											],
											[
												55.387,
												-12.468
											],
											[
												56.055,
												-21.467
											],
											[
												53.043,
												-28.938
											],
											[
												47.314,
												-34.644
											],
											[
												39.534,
												-38.762
											],
											[
												31.819,
												-41.276
											],
											[
												26.423,
												-43.221
											],
											[
												22.119,
												-45.833
											],
											[
												19.319,
												-49.341
											],
											[
												18.896,
												-54.003
											],
											[
												20.442,
												-57.878
											],
											[
												23.478,
												-60.693
											],
											[
												27.767,
												-62.271
											],
											[
												33.203,
												-62.5
											],
											[
												38.134,
												-61.035
											],
											[
												41.642,
												-58.057
											],
											[
												43.693,
												-53.816
											],
											[
												44.238,
												-50.391
											],
											[
												55.924,
												-53.614
											],
											[
												52.653,
												-61.857
											],
											[
												46.427,
												-67.944
											],
											[
												37.866,
												-71.54
											],
											[
												28.059,
												-72.07
											],
											[
												19.14,
												-69.791
											],
											[
												12.141,
												-65.104
											],
											[
												7.74,
												-58.195
											],
											[
												7.08,
												-49.333
											],
											[
												10.376,
												-41.984
											],
											[
												16.365,
												-36.466
											],
											[
												24.227,
												-32.584
											],
											[
												31.868,
												-30.143
											],
											[
												37.345,
												-28.003
											],
											[
												41.447,
												-25.195
											],
											[
												43.84,
												-21.492
											],
											[
												44.189,
												-16.749
											]
										],
										"v": [
											[
												43.213,
												-14.136
											],
											[
												40.527,
												-11.06
											],
											[
												36.523,
												-9.18
											],
											[
												31.592,
												-8.545
											],
											[
												25.806,
												-9.351
											],
											[
												21.24,
												-11.743
											],
											[
												18.115,
												-15.723
											],
											[
												16.699,
												-21.338
											],
											[
												4.932,
												-21.338
											],
											[
												6.055,
												-14.624
											],
											[
												9.009,
												-9.106
											],
											[
												13.428,
												-4.761
											],
											[
												18.921,
												-1.611
											],
											[
												25.098,
												0.293
											],
											[
												31.592,
												0.928
											],
											[
												40.869,
												-0.317
											],
											[
												48.682,
												-4.004
											],
											[
												54.053,
												-10.059
											],
											[
												56.055,
												-18.408
											],
											[
												54.248,
												-26.562
											],
											[
												49.365,
												-32.837
											],
											[
												42.236,
												-37.476
											],
											[
												33.74,
												-40.723
											],
											[
												28.198,
												-42.554
											],
											[
												23.486,
												-44.922
											],
											[
												20.166,
												-48.12
											],
											[
												18.896,
												-52.441
											],
											[
												19.824,
												-56.641
											],
											[
												22.388,
												-59.814
											],
											[
												26.27,
												-61.816
											],
											[
												31.152,
												-62.5
											],
											[
												36.572,
												-61.621
											],
											[
												40.552,
												-59.131
											],
											[
												43.091,
												-55.298
											],
											[
												44.238,
												-50.391
											],
											[
												55.957,
												-50.391
											],
											[
												53.955,
												-59.204
											],
											[
												48.657,
												-66.04
											],
											[
												40.845,
												-70.483
											],
											[
												31.25,
												-72.07
											],
											[
												22.07,
												-70.703
											],
											[
												14.355,
												-66.797
											],
											[
												9.058,
												-60.62
											],
											[
												7.08,
												-52.393
											],
											[
												9.058,
												-44.312
											],
											[
												14.233,
												-38.208
											],
											[
												21.509,
												-33.789
											],
											[
												29.785,
												-30.762
											],
											[
												35.571,
												-28.735
											],
											[
												40.161,
												-26.172
											],
											[
												43.14,
												-22.778
											],
											[
												44.189,
												-18.311
											]
										],
										"c": true
									}
								},
								"nm": "S",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "S",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0.651,
												-1.221
											],
											[
												1.139,
												-0.83
											],
											[
												1.53,
												-0.423
											],
											[
												1.758,
												0
											],
											[
												1.741,
												0.537
											],
											[
												1.302,
												1.058
											],
											[
												0.781,
												1.595
											],
											[
												0.163,
												2.148
											],
											[
												0,
												0
											],
											[
												-0.716,
												-2.034
											],
											[
												-1.254,
												-1.643
											],
											[
												-1.693,
												-1.253
											],
											[
												-1.97,
												-0.846
											],
											[
												-2.148,
												-0.423
											],
											[
												-2.181,
												0
											],
											[
												-2.962,
												0.83
											],
											[
												-2.246,
												1.628
											],
											[
												-1.335,
												2.409
											],
											[
												0,
												3.158
											],
											[
												1.204,
												2.377
											],
											[
												2.051,
												1.807
											],
											[
												2.702,
												1.286
											],
											[
												2.962,
												0.879
											],
											[
												1.774,
												0.668
											],
											[
												1.367,
												0.912
											],
											[
												0.846,
												1.221
											],
											[
												0,
												1.66
											],
											[
												-0.619,
												1.237
											],
											[
												-1.091,
												0.879
											],
											[
												-1.498,
												0.456
											],
											[
												-1.758,
												0
											],
											[
												-1.562,
												-0.586
											],
											[
												-1.091,
												-1.074
											],
											[
												-0.603,
												-1.481
											],
											[
												-0.163,
												-1.79
											],
											[
												0,
												0
											],
											[
												1.302,
												2.654
											],
											[
												2.229,
												1.904
											],
											[
												2.979,
												1.058
											],
											[
												3.418,
												0
											],
											[
												2.93,
												-0.911
											],
											[
												2.213,
												-1.692
											],
											[
												1.318,
												-2.425
											],
											[
												0,
												-3.059
											],
											[
												-1.318,
												-2.327
											],
											[
												-2.132,
												-1.741
											],
											[
												-2.718,
												-1.204
											],
											[
												-2.8,
												-0.813
											],
											[
												-1.775,
												-0.732
											],
											[
												-1.286,
												-0.977
											],
											[
												-0.7,
												-1.286
											],
											[
												0,
												-1.692
											]
										],
										"o": [
											[
												-0.652,
												1.221
											],
											[
												-1.14,
												0.83
											],
											[
												-1.53,
												0.423
											],
											[
												-2.116,
												0
											],
											[
												-1.742,
												-0.537
											],
											[
												-1.302,
												-1.057
											],
											[
												-0.781,
												-1.595
											],
											[
												0,
												0
											],
											[
												0.032,
												2.441
											],
											[
												0.716,
												2.035
											],
											[
												1.253,
												1.644
											],
											[
												1.692,
												1.254
											],
											[
												1.969,
												0.847
											],
											[
												2.148,
												0.423
											],
											[
												3.223,
												0
											],
											[
												2.962,
												-0.83
											],
											[
												2.246,
												-1.627
											],
											[
												1.334,
												-2.409
											],
											[
												0,
												-3.059
											],
											[
												-1.205,
												-2.376
											],
											[
												-2.051,
												-1.807
											],
											[
												-2.702,
												-1.286
											],
											[
												-1.921,
												-0.553
											],
											[
												-1.775,
												-0.667
											],
											[
												-1.367,
												-0.911
											],
											[
												-0.847,
												-1.221
											],
											[
												0,
												-1.562
											],
											[
												0.618,
												-1.237
											],
											[
												1.09,
												-0.879
											],
											[
												1.497,
												-0.455
											],
											[
												2.051,
												0
											],
											[
												1.562,
												0.586
											],
											[
												1.09,
												1.074
											],
											[
												0.602,
												1.482
											],
											[
												0,
												0
											],
											[
												-0.033,
												-3.223
											],
											[
												-1.302,
												-2.653
											],
											[
												-2.23,
												-1.904
											],
											[
												-2.979,
												-1.057
											],
											[
												-3.191,
												0
											],
											[
												-2.93,
												0.912
											],
											[
												-2.214,
												1.693
											],
											[
												-1.318,
												2.425
											],
											[
												0,
												3.06
											],
											[
												1.318,
												2.328
											],
											[
												2.132,
												1.742
											],
											[
												2.718,
												1.205
											],
											[
												2.083,
												0.619
											],
											[
												1.774,
												0.732
											],
											[
												1.286,
												0.977
											],
											[
												0.7,
												1.286
											],
											[
												0,
												1.562
											]
										],
										"v": [
											[
												103.223,
												-14.136
											],
											[
												100.537,
												-11.06
											],
											[
												96.533,
												-9.18
											],
											[
												91.602,
												-8.545
											],
											[
												85.815,
												-9.351
											],
											[
												81.25,
												-11.743
											],
											[
												78.125,
												-15.723
											],
											[
												76.709,
												-21.338
											],
											[
												64.941,
												-21.338
											],
											[
												66.064,
												-14.624
											],
											[
												69.019,
												-9.106
											],
											[
												73.438,
												-4.761
											],
											[
												78.931,
												-1.611
											],
											[
												85.107,
												0.293
											],
											[
												91.602,
												0.928
											],
											[
												100.879,
												-0.317
											],
											[
												108.691,
												-4.004
											],
											[
												114.062,
												-10.059
											],
											[
												116.064,
												-18.408
											],
											[
												114.258,
												-26.562
											],
											[
												109.375,
												-32.837
											],
											[
												102.246,
												-37.476
											],
											[
												93.75,
												-40.723
											],
											[
												88.208,
												-42.554
											],
											[
												83.496,
												-44.922
											],
											[
												80.176,
												-48.12
											],
											[
												78.906,
												-52.441
											],
											[
												79.834,
												-56.641
											],
											[
												82.397,
												-59.814
											],
											[
												86.279,
												-61.816
											],
											[
												91.162,
												-62.5
											],
											[
												96.582,
												-61.621
											],
											[
												100.562,
												-59.131
											],
											[
												103.101,
												-55.298
											],
											[
												104.248,
												-50.391
											],
											[
												115.967,
												-50.391
											],
											[
												113.965,
												-59.204
											],
											[
												108.667,
												-66.04
											],
											[
												100.854,
												-70.483
											],
											[
												91.26,
												-72.07
											],
											[
												82.08,
												-70.703
											],
											[
												74.365,
												-66.797
											],
											[
												69.067,
												-60.62
											],
											[
												67.09,
												-52.393
											],
											[
												69.067,
												-44.312
											],
											[
												74.243,
												-38.208
											],
											[
												81.519,
												-33.789
											],
											[
												89.795,
												-30.762
											],
											[
												95.581,
												-28.735
											],
											[
												100.171,
												-26.172
											],
											[
												103.149,
												-22.778
											],
											[
												104.199,
												-18.311
											]
										],
										"c": true
									}
								},
								"nm": "S",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "S",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "E",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												48.926,
												-41.357
											],
											[
												19.678,
												-41.357
											],
											[
												19.678,
												-61.426
											],
											[
												53.564,
												-61.426
											],
											[
												53.564,
												-71.094
											],
											[
												7.91,
												-71.094
											],
											[
												7.91,
												0
											],
											[
												53.906,
												0
											],
											[
												53.906,
												-9.57
											],
											[
												19.678,
												-9.57
											],
											[
												19.678,
												-31.885
											],
											[
												48.926,
												-31.885
											]
										],
										"o": [
											[
												48.926,
												-41.357
											],
											[
												19.678,
												-41.357
											],
											[
												19.678,
												-61.426
											],
											[
												53.564,
												-61.426
											],
											[
												53.564,
												-71.094
											],
											[
												7.91,
												-71.094
											],
											[
												7.91,
												0
											],
											[
												53.906,
												0
											],
											[
												53.906,
												-9.57
											],
											[
												19.678,
												-9.57
											],
											[
												19.678,
												-31.885
											],
											[
												48.926,
												-31.885
											]
										],
										"v": [
											[
												48.926,
												-41.357
											],
											[
												19.678,
												-41.357
											],
											[
												19.678,
												-61.426
											],
											[
												53.564,
												-61.426
											],
											[
												53.564,
												-71.094
											],
											[
												7.91,
												-71.094
											],
											[
												7.91,
												0
											],
											[
												53.906,
												0
											],
											[
												53.906,
												-9.57
											],
											[
												19.678,
												-9.57
											],
											[
												19.678,
												-31.885
											],
											[
												48.926,
												-31.885
											]
										],
										"c": true
									}
								},
								"nm": "E",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "E",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												108.936,
												-41.357
											],
											[
												79.688,
												-41.357
											],
											[
												79.688,
												-61.426
											],
											[
												113.574,
												-61.426
											],
											[
												113.574,
												-71.094
											],
											[
												67.92,
												-71.094
											],
											[
												67.92,
												0
											],
											[
												113.916,
												0
											],
											[
												113.916,
												-9.57
											],
											[
												79.688,
												-9.57
											],
											[
												79.688,
												-31.885
											],
											[
												108.936,
												-31.885
											]
										],
										"c": true
									}
								},
								"nm": "E",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "E",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "C",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												43.506,
												-21.826
											],
											[
												41.845,
												-14.265
											],
											[
												34.424,
												-8.447
											],
											[
												25.423,
												-9.033
											],
											[
												20.41,
												-12.971
											],
											[
												17.488,
												-19.36
											],
											[
												16.309,
												-27.604
											],
											[
												16.309,
												-40.479
											],
											[
												16.545,
												-46.207
											],
											[
												18.278,
												-53.898
											],
											[
												21.939,
												-59.586
											],
											[
												27.734,
												-62.598
											],
											[
												34.383,
												-62.272
											],
											[
												38.851,
												-60.034
											],
											[
												41.755,
												-56.128
											],
											[
												43.36,
												-50.813
											],
											[
												55.273,
												-48.73
											],
											[
												54.118,
												-55.5
											],
											[
												49.983,
												-63.752
											],
											[
												43.311,
												-69.352
											],
											[
												34.114,
												-72.119
											],
											[
												22.364,
												-71.28
											],
											[
												13.224,
												-65.65
											],
											[
												7.258,
												-56.518
											],
											[
												4.475,
												-44.71
											],
											[
												4.443,
												-30.664
											],
											[
												5.03,
												-22.2
											],
											[
												8.79,
												-11.165
											],
											[
												15.771,
												-3.165
											],
											[
												25.992,
												1.025
											],
											[
												37.149,
												0.48
											],
											[
												45.508,
												-3.247
											],
											[
												51.53,
												-9.66
											],
											[
												54.947,
												-18.408
											]
										],
										"o": [
											[
												43.115,
												-17.561
											],
											[
												37.549,
												-9.61
											],
											[
												27.652,
												-8.447
											],
											[
												21.842,
												-11.377
											],
											[
												18.262,
												-17.008
											],
											[
												16.545,
												-24.732
											],
											[
												16.309,
												-30.664
											],
											[
												16.309,
												-43.409
											],
											[
												17.488,
												-51.546
											],
											[
												20.491,
												-57.967
											],
											[
												25.52,
												-61.995
											],
											[
												32.519,
												-62.598
											],
											[
												37.541,
												-60.969
											],
											[
												40.934,
												-57.592
											],
											[
												42.96,
												-52.71
											],
											[
												43.555,
												-48.73
											],
											[
												54.914,
												-52.278
											],
											[
												51.644,
												-61.295
											],
											[
												45.816,
												-67.789
											],
											[
												37.451,
												-71.565
											],
											[
												26.106,
												-72.119
											],
											[
												15.918,
												-67.927
											],
											[
												8.895,
												-59.888
											],
											[
												5.045,
												-48.804
											],
											[
												4.443,
												-40.381
											],
											[
												4.475,
												-26.302
											],
											[
												7.178,
												-14.518
											],
											[
												13.086,
												-5.436
											],
											[
												22.217,
												0.187
											],
											[
												33.902,
												1.025
											],
											[
												42.976,
												-1.7
											],
											[
												49.804,
												-7.251
											],
											[
												54.134,
												-15.291
											],
											[
												55.273,
												-21.826
											]
										],
										"v": [
											[
												43.506,
												-21.826
											],
											[
												39.697,
												-11.938
											],
											[
												30.322,
												-8.447
											],
											[
												23.633,
												-10.205
											],
											[
												19.336,
												-14.99
											],
											[
												17.017,
												-22.046
											],
											[
												16.309,
												-30.664
											],
											[
												16.309,
												-40.479
											],
											[
												17.017,
												-48.877
											],
											[
												19.385,
												-55.933
											],
											[
												23.73,
												-60.791
											],
											[
												30.371,
												-62.598
											],
											[
												35.962,
												-61.621
											],
											[
												39.893,
												-58.813
											],
											[
												42.358,
												-54.419
											],
											[
												43.555,
												-48.73
											],
											[
												55.273,
												-48.73
											],
											[
												52.881,
												-58.398
											],
											[
												47.9,
												-65.771
											],
											[
												40.381,
												-70.459
											],
											[
												30.371,
												-72.119
											],
											[
												19.141,
												-69.604
											],
											[
												11.06,
												-62.769
											],
											[
												6.152,
												-52.661
											],
											[
												4.443,
												-40.381
											],
											[
												4.443,
												-30.664
											],
											[
												6.104,
												-18.359
											],
											[
												10.938,
												-8.301
											],
											[
												18.994,
												-1.489
											],
											[
												30.322,
												1.025
											],
											[
												40.063,
												-0.61
											],
											[
												47.656,
												-5.249
											],
											[
												52.832,
												-12.476
											],
											[
												55.273,
												-21.826
											]
										],
										"c": true
									}
								},
								"nm": "C",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "C",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												2.148,
												-2.327
											],
											[
												4.102,
												0
											],
											[
												1.79,
												1.172
											],
											[
												1.074,
												2.019
											],
											[
												0.471,
												2.686
											],
											[
												0,
												3.06
											],
											[
												0,
												0
											],
											[
												-0.472,
												2.67
											],
											[
												-1.107,
												2.035
											],
											[
												-1.791,
												1.205
											],
											[
												-2.637,
												0
											],
											[
												-1.579,
												-0.651
											],
											[
												-1.042,
												-1.221
											],
											[
												-0.603,
												-1.709
											],
											[
												-0.195,
												-2.083
											],
											[
												0,
												0
											],
											[
												1.237,
												2.898
											],
											[
												2.083,
												2.019
											],
											[
												2.93,
												1.107
											],
											[
												3.743,
												0
											],
											[
												3.223,
												-1.676
											],
											[
												2.164,
												-2.881
											],
											[
												1.106,
												-3.857
											],
											[
												0.032,
												-4.329
											],
											[
												0,
												0
											],
											[
												-1.074,
												-3.841
											],
											[
												-2.148,
												-2.864
											],
											[
												-3.223,
												-1.676
											],
											[
												-4.33,
												0
											],
											[
												-2.914,
												1.09
											],
											[
												-2.148,
												2.002
											],
											[
												-1.302,
												2.816
											],
											[
												-0.326,
												3.418
											]
										],
										"o": [
											[
												-0.391,
												4.265
											],
											[
												-2.148,
												2.328
											],
											[
												-2.67,
												0
											],
											[
												-1.791,
												-1.172
											],
											[
												-1.074,
												-2.018
											],
											[
												-0.472,
												-2.686
											],
											[
												0,
												0
											],
											[
												0,
												-2.93
											],
											[
												0.471,
												-2.669
											],
											[
												1.106,
												-2.034
											],
											[
												1.79,
												-1.204
											],
											[
												2.148,
												0
											],
											[
												1.579,
												0.652
											],
											[
												1.041,
												1.221
											],
											[
												0.602,
												1.709
											],
											[
												0,
												0
											],
											[
												-0.359,
												-3.548
											],
											[
												-1.237,
												-2.897
											],
											[
												-2.084,
												-2.018
											],
											[
												-2.93,
												-1.106
											],
											[
												-4.265,
												0
											],
											[
												-3.223,
												1.677
											],
											[
												-2.165,
												2.881
											],
											[
												-1.107,
												3.857
											],
											[
												0,
												0
											],
											[
												0.032,
												4.362
											],
											[
												1.074,
												3.841
											],
											[
												2.148,
												2.865
											],
											[
												3.223,
												1.676
											],
											[
												3.58,
												0
											],
											[
												2.913,
												-1.09
											],
											[
												2.148,
												-2.002
											],
											[
												1.302,
												-2.815
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												103.516,
												-21.826
											],
											[
												99.707,
												-11.938
											],
											[
												90.332,
												-8.447
											],
											[
												83.643,
												-10.205
											],
											[
												79.346,
												-14.99
											],
											[
												77.026,
												-22.046
											],
											[
												76.318,
												-30.664
											],
											[
												76.318,
												-40.479
											],
											[
												77.026,
												-48.877
											],
											[
												79.395,
												-55.933
											],
											[
												83.74,
												-60.791
											],
											[
												90.381,
												-62.598
											],
											[
												95.972,
												-61.621
											],
											[
												99.902,
												-58.813
											],
											[
												102.368,
												-54.419
											],
											[
												103.564,
												-48.73
											],
											[
												115.283,
												-48.73
											],
											[
												112.891,
												-58.398
											],
											[
												107.91,
												-65.771
											],
											[
												100.391,
												-70.459
											],
											[
												90.381,
												-72.119
											],
											[
												79.15,
												-69.604
											],
											[
												71.069,
												-62.769
											],
											[
												66.162,
												-52.661
											],
											[
												64.453,
												-40.381
											],
											[
												64.453,
												-30.664
											],
											[
												66.113,
												-18.359
											],
											[
												70.947,
												-8.301
											],
											[
												79.004,
												-1.489
											],
											[
												90.332,
												1.025
											],
											[
												100.073,
												-0.61
											],
											[
												107.666,
												-5.249
											],
											[
												112.842,
												-12.476
											],
											[
												115.283,
												-21.826
											]
										],
										"c": true
									}
								},
								"nm": "C",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "C",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "U",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												41.992,
												-71.094
											],
											[
												41.895,
												-23.486
											],
											[
												41.584,
												-19.303
											],
											[
												39.779,
												-14.087
											],
											[
												36.507,
												-10.424
											],
											[
												31.787,
												-8.594
											],
											[
												26.228,
												-8.96
											],
											[
												22.12,
												-11.451
											],
											[
												19.416,
												-15.657
											],
											[
												18.098,
												-21.305
											],
											[
												17.969,
												-71.094
											],
											[
												6.445,
												-71.094
											],
											[
												6.348,
												-23.486
											],
											[
												6.965,
												-16.463
											],
											[
												10.84,
												-7.869
											],
											[
												17.399,
												-1.953
											],
											[
												26.318,
												0.977
											],
											[
												36.71,
												0.391
											],
											[
												45.019,
												-3.614
											],
											[
												50.715,
												-10.49
											],
											[
												53.58,
												-19.84
											],
											[
												53.516,
												-71.094
											]
										],
										"o": [
											[
												41.992,
												-71.094
											],
											[
												41.862,
												-21.305
											],
											[
												40.543,
												-15.657
											],
											[
												37.761,
												-11.451
											],
											[
												33.512,
												-8.96
											],
											[
												27.913,
												-8.594
											],
											[
												23.331,
												-10.424
											],
											[
												20.166,
												-14.087
											],
											[
												18.375,
												-19.303
											],
											[
												18.066,
												-23.486
											],
											[
												17.969,
												-71.094
											],
											[
												6.445,
												-71.094
											],
											[
												6.38,
												-19.807
											],
											[
												9.244,
												-10.441
											],
											[
												14.942,
												-3.605
											],
											[
												23.128,
												0.391
											],
											[
												33.447,
												0.977
											],
											[
												42.537,
												-1.953
											],
											[
												49.121,
												-7.91
											],
											[
												52.994,
												-16.512
											],
											[
												53.613,
												-23.486
											],
											[
												53.516,
												-71.094
											]
										],
										"v": [
											[
												41.992,
												-71.094
											],
											[
												41.895,
												-23.486
											],
											[
												41.064,
												-17.48
											],
											[
												38.77,
												-12.769
											],
											[
												35.01,
												-9.692
											],
											[
												29.834,
												-8.594
											],
											[
												24.78,
												-9.692
											],
											[
												21.143,
												-12.769
											],
											[
												18.896,
												-17.48
											],
											[
												18.066,
												-23.486
											],
											[
												17.969,
												-71.094
											],
											[
												6.445,
												-71.094
											],
											[
												6.348,
												-23.486
											],
											[
												8.105,
												-13.452
											],
											[
												12.891,
												-5.737
											],
											[
												20.264,
												-0.781
											],
											[
												29.834,
												0.977
											],
											[
												39.624,
												-0.781
											],
											[
												47.07,
												-5.762
											],
											[
												51.855,
												-13.501
											],
											[
												53.613,
												-23.486
											],
											[
												53.516,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "U",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "U",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.52,
												-1.823
											],
											[
												1.009,
												-1.318
											],
											[
												1.497,
												-0.732
											],
											[
												1.953,
												0
											],
											[
												1.448,
												0.732
											],
											[
												0.977,
												1.318
											],
											[
												0.52,
												1.823
											],
											[
												0.032,
												2.181
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.14,
												-3.011
											],
											[
												-2.051,
												-2.132
											],
											[
												-2.865,
												-1.172
											],
											[
												-3.516,
												0
											],
											[
												-2.914,
												1.172
											],
											[
												-2.051,
												2.148
											],
											[
												-1.14,
												3.011
											],
											[
												-0.033,
												3.646
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												-0.033,
												2.181
											],
											[
												-0.521,
												1.823
											],
											[
												-1.009,
												1.318
											],
											[
												-1.498,
												0.732
											],
											[
												-1.921,
												0
											],
											[
												-1.449,
												-0.732
											],
											[
												-0.977,
												-1.318
											],
											[
												-0.521,
												-1.823
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.032,
												3.679
											],
											[
												1.139,
												3.011
											],
											[
												2.051,
												2.132
											],
											[
												2.864,
												1.172
											],
											[
												3.613,
												0
											],
											[
												2.913,
												-1.172
											],
											[
												2.051,
												-2.148
											],
											[
												1.139,
												-3.011
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												102.002,
												-71.094
											],
											[
												101.904,
												-23.486
											],
											[
												101.074,
												-17.48
											],
											[
												98.779,
												-12.769
											],
											[
												95.02,
												-9.692
											],
											[
												89.844,
												-8.594
											],
											[
												84.79,
												-9.692
											],
											[
												81.152,
												-12.769
											],
											[
												78.906,
												-17.48
											],
											[
												78.076,
												-23.486
											],
											[
												77.979,
												-71.094
											],
											[
												66.455,
												-71.094
											],
											[
												66.357,
												-23.486
											],
											[
												68.115,
												-13.452
											],
											[
												72.9,
												-5.737
											],
											[
												80.273,
												-0.781
											],
											[
												89.844,
												0.977
											],
											[
												99.634,
												-0.781
											],
											[
												107.08,
												-5.762
											],
											[
												111.865,
												-13.501
											],
											[
												113.623,
												-23.486
											],
											[
												113.525,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "U",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "U",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "R",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												44.629,
												0
											],
											[
												57.129,
												0
											],
											[
												57.129,
												-0.586
											],
											[
												42.09,
												-30.469
											],
											[
												45.768,
												-32.34
											],
											[
												50.325,
												-36.149
											],
											[
												53.491,
												-41.121
											],
											[
												55.078,
												-47.249
											],
											[
												54.46,
												-56.363
											],
											[
												50.244,
												-63.923
											],
											[
												43.091,
												-68.806
											],
											[
												33.577,
												-71.061
											],
											[
												7.471,
												-71.094
											],
											[
												7.471,
												0
											],
											[
												19.189,
												0
											],
											[
												19.189,
												-27.734
											],
											[
												31.104,
												-27.734
											]
										],
										"o": [
											[
												44.629,
												0
											],
											[
												57.129,
												0
											],
											[
												57.129,
												-0.586
											],
											[
												44.01,
												-31.315
											],
											[
												48.958,
												-34.749
											],
											[
												52.604,
												-39.339
											],
											[
												54.761,
												-45.06
											],
											[
												55.078,
												-53.238
											],
											[
												51.986,
												-61.702
											],
											[
												45.752,
												-67.472
											],
											[
												36.939,
												-70.597
											],
											[
												29.932,
												-71.094
											],
											[
												7.471,
												-71.094
											],
											[
												7.471,
												0
											],
											[
												19.189,
												0
											],
											[
												19.189,
												-27.734
											],
											[
												31.104,
												-27.734
											]
										],
										"v": [
											[
												44.629,
												0
											],
											[
												57.129,
												0
											],
											[
												57.129,
												-0.586
											],
											[
												42.09,
												-30.469
											],
											[
												47.363,
												-33.545
											],
											[
												51.465,
												-37.744
											],
											[
												54.126,
												-43.091
											],
											[
												55.078,
												-49.658
											],
											[
												53.223,
												-59.033
											],
											[
												47.998,
												-65.698
											],
											[
												40.015,
												-69.702
											],
											[
												29.932,
												-71.094
											],
											[
												7.471,
												-71.094
											],
											[
												7.471,
												0
											],
											[
												19.189,
												0
											],
											[
												19.189,
												-27.734
											],
											[
												31.104,
												-27.734
											]
										],
										"c": true
									}
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												19.189,
												-61.621
											],
											[
												29.932,
												-61.621
											],
											[
												33.838,
												-61.304
											],
											[
												38.566,
												-59.439
											],
											[
												41.764,
												-56.071
											],
											[
												43.311,
												-51.253
											],
											[
												42.985,
												-45.646
											],
											[
												40.763,
												-41.43
											],
											[
												36.979,
												-38.59
											],
											[
												31.933,
												-37.207
											],
											[
												19.189,
												-37.207
											]
										],
										"o": [
											[
												19.189,
												-61.621
											],
											[
												31.983,
												-61.588
											],
											[
												37.158,
												-60.23
											],
											[
												40.877,
												-57.356
											],
											[
												43.001,
												-53.011
											],
											[
												43.311,
												-47.347
											],
											[
												41.682,
												-42.683
											],
											[
												38.386,
												-39.38
											],
											[
												33.724,
												-37.483
											],
											[
												29.98,
												-37.207
											],
											[
												19.189,
												-37.207
											]
										],
										"v": [
											[
												19.189,
												-61.621
											],
											[
												29.932,
												-61.621
											],
											[
												35.498,
												-60.767
											],
											[
												39.722,
												-58.398
											],
											[
												42.383,
												-54.541
											],
											[
												43.311,
												-49.268
											],
											[
												42.334,
												-44.165
											],
											[
												39.575,
												-40.405
											],
											[
												35.352,
												-38.037
											],
											[
												29.98,
												-37.207
											],
											[
												19.189,
												-37.207
											]
										],
										"c": true
									}
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "R",
						"np": 5,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.595,
												1.205
											],
											[
												-1.14,
												1.595
											],
											[
												-0.635,
												1.97
											],
											[
												0,
												2.409
											],
											[
												1.237,
												2.67
											],
											[
												2.246,
												1.775
											],
											[
												3.076,
												0.896
											],
											[
												3.645,
												0.033
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												1.92,
												-0.846
											],
											[
												1.595,
												-1.204
											],
											[
												1.139,
												-1.595
											],
											[
												0.635,
												-1.969
											],
											[
												0,
												-3.58
											],
											[
												-1.237,
												-2.669
											],
											[
												-2.246,
												-1.774
											],
											[
												-3.076,
												-0.895
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												104.639,
												0
											],
											[
												117.139,
												0
											],
											[
												117.139,
												-0.586
											],
											[
												102.1,
												-30.469
											],
											[
												107.373,
												-33.545
											],
											[
												111.475,
												-37.744
											],
											[
												114.136,
												-43.091
											],
											[
												115.088,
												-49.658
											],
											[
												113.232,
												-59.033
											],
											[
												108.008,
												-65.698
											],
											[
												100.024,
												-69.702
											],
											[
												89.941,
												-71.094
											],
											[
												67.48,
												-71.094
											],
											[
												67.48,
												0
											],
											[
												79.199,
												0
											],
											[
												79.199,
												-27.734
											],
											[
												91.113,
												-27.734
											]
										],
										"c": true
									}
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.66,
												-0.537
											],
											[
												-1.156,
												-1.041
											],
											[
												-0.619,
												-1.53
											],
											[
												0,
												-1.985
											],
											[
												0.651,
												-1.481
											],
											[
												1.188,
												-1.025
											],
											[
												1.627,
												-0.553
											],
											[
												1.953,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												2.051,
												0.033
											],
											[
												1.66,
												0.537
											],
											[
												1.155,
												1.042
											],
											[
												0.618,
												1.53
											],
											[
												0,
												1.921
											],
											[
												-0.652,
												1.482
											],
											[
												-1.189,
												1.025
											],
											[
												-1.628,
												0.554
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												79.199,
												-61.621
											],
											[
												89.941,
												-61.621
											],
											[
												95.508,
												-60.767
											],
											[
												99.731,
												-58.398
											],
											[
												102.393,
												-54.541
											],
											[
												103.32,
												-49.268
											],
											[
												102.344,
												-44.165
											],
											[
												99.585,
												-40.405
											],
											[
												95.361,
												-38.037
											],
											[
												89.99,
												-37.207
											],
											[
												79.199,
												-37.207
											]
										],
										"c": true
									}
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "R",
						"np": 5,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "I",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												8.838,
												-61.377
											],
											[
												23.877,
												-61.377
											],
											[
												23.877,
												-9.668
											],
											[
												8.838,
												-9.668
											],
											[
												8.838,
												0
											],
											[
												51.123,
												0
											],
											[
												51.123,
												-9.668
											],
											[
												35.742,
												-9.668
											],
											[
												35.742,
												-61.377
											],
											[
												51.123,
												-61.377
											],
											[
												51.123,
												-71.094
											],
											[
												8.838,
												-71.094
											]
										],
										"o": [
											[
												8.838,
												-61.377
											],
											[
												23.877,
												-61.377
											],
											[
												23.877,
												-9.668
											],
											[
												8.838,
												-9.668
											],
											[
												8.838,
												0
											],
											[
												51.123,
												0
											],
											[
												51.123,
												-9.668
											],
											[
												35.742,
												-9.668
											],
											[
												35.742,
												-61.377
											],
											[
												51.123,
												-61.377
											],
											[
												51.123,
												-71.094
											],
											[
												8.838,
												-71.094
											]
										],
										"v": [
											[
												8.838,
												-61.377
											],
											[
												23.877,
												-61.377
											],
											[
												23.877,
												-9.668
											],
											[
												8.838,
												-9.668
											],
											[
												8.838,
												0
											],
											[
												51.123,
												0
											],
											[
												51.123,
												-9.668
											],
											[
												35.742,
												-9.668
											],
											[
												35.742,
												-61.377
											],
											[
												51.123,
												-61.377
											],
											[
												51.123,
												-71.094
											],
											[
												8.838,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "I",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "I",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												68.848,
												-61.377
											],
											[
												83.887,
												-61.377
											],
											[
												83.887,
												-9.668
											],
											[
												68.848,
												-9.668
											],
											[
												68.848,
												0
											],
											[
												111.133,
												0
											],
											[
												111.133,
												-9.668
											],
											[
												95.752,
												-9.668
											],
											[
												95.752,
												-61.377
											],
											[
												111.133,
												-61.377
											],
											[
												111.133,
												-71.094
											],
											[
												68.848,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "I",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "I",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "T",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												57.617,
												-71.094
											],
											[
												2.441,
												-71.094
											],
											[
												2.441,
												-61.426
											],
											[
												24.121,
												-61.426
											],
											[
												24.121,
												0
											],
											[
												35.791,
												0
											],
											[
												35.791,
												-61.426
											],
											[
												57.617,
												-61.426
											]
										],
										"o": [
											[
												57.617,
												-71.094
											],
											[
												2.441,
												-71.094
											],
											[
												2.441,
												-61.426
											],
											[
												24.121,
												-61.426
											],
											[
												24.121,
												0
											],
											[
												35.791,
												0
											],
											[
												35.791,
												-61.426
											],
											[
												57.617,
												-61.426
											]
										],
										"v": [
											[
												57.617,
												-71.094
											],
											[
												2.441,
												-71.094
											],
											[
												2.441,
												-61.426
											],
											[
												24.121,
												-61.426
											],
											[
												24.121,
												0
											],
											[
												35.791,
												0
											],
											[
												35.791,
												-61.426
											],
											[
												57.617,
												-61.426
											]
										],
										"c": true
									}
								},
								"nm": "T",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "T",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												117.627,
												-71.094
											],
											[
												62.451,
												-71.094
											],
											[
												62.451,
												-61.426
											],
											[
												84.131,
												-61.426
											],
											[
												84.131,
												0
											],
											[
												95.801,
												0
											],
											[
												95.801,
												-61.426
											],
											[
												117.627,
												-61.426
											]
										],
										"c": true
									}
								},
								"nm": "T",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "T",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "Y",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												15.283,
												-71.094
											],
											[
												2.197,
												-71.094
											],
											[
												24.219,
												-25.83
											],
											[
												24.316,
												0
											],
											[
												35.693,
												0
											],
											[
												35.791,
												-25.537
											],
											[
												57.959,
												-71.094
											],
											[
												44.873,
												-71.094
											],
											[
												30.078,
												-37.109
											]
										],
										"o": [
											[
												15.283,
												-71.094
											],
											[
												2.197,
												-71.094
											],
											[
												24.219,
												-25.83
											],
											[
												24.316,
												0
											],
											[
												35.693,
												0
											],
											[
												35.791,
												-25.537
											],
											[
												57.959,
												-71.094
											],
											[
												44.873,
												-71.094
											],
											[
												30.078,
												-37.109
											]
										],
										"v": [
											[
												15.283,
												-71.094
											],
											[
												2.197,
												-71.094
											],
											[
												24.219,
												-25.83
											],
											[
												24.316,
												0
											],
											[
												35.693,
												0
											],
											[
												35.791,
												-25.537
											],
											[
												57.959,
												-71.094
											],
											[
												44.873,
												-71.094
											],
											[
												30.078,
												-37.109
											]
										],
										"c": true
									}
								},
								"nm": "Y",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "Y",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												75.293,
												-71.094
											],
											[
												62.207,
												-71.094
											],
											[
												84.229,
												-25.83
											],
											[
												84.326,
												0
											],
											[
												95.703,
												0
											],
											[
												95.801,
												-25.537
											],
											[
												117.969,
												-71.094
											],
											[
												104.883,
												-71.094
											],
											[
												90.088,
												-37.109
											]
										],
										"c": true
									}
								},
								"nm": "Y",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "Y",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "N",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												53.271,
												-71.094
											],
											[
												41.406,
												-71.094
											],
											[
												41.309,
												-22.314
											],
											[
												18.262,
												-71.094
											],
											[
												6.396,
												-71.094
											],
											[
												6.396,
												0
											],
											[
												18.262,
												0
											],
											[
												18.311,
												-48.926
											],
											[
												41.455,
												0
											],
											[
												53.271,
												0
											]
										],
										"o": [
											[
												53.271,
												-71.094
											],
											[
												41.406,
												-71.094
											],
											[
												41.309,
												-22.314
											],
											[
												18.262,
												-71.094
											],
											[
												6.396,
												-71.094
											],
											[
												6.396,
												0
											],
											[
												18.262,
												0
											],
											[
												18.311,
												-48.926
											],
											[
												41.455,
												0
											],
											[
												53.271,
												0
											]
										],
										"v": [
											[
												53.271,
												-71.094
											],
											[
												41.406,
												-71.094
											],
											[
												41.309,
												-22.314
											],
											[
												18.262,
												-71.094
											],
											[
												6.396,
												-71.094
											],
											[
												6.396,
												0
											],
											[
												18.262,
												0
											],
											[
												18.311,
												-48.926
											],
											[
												41.455,
												0
											],
											[
												53.271,
												0
											]
										],
										"c": true
									}
								},
								"nm": "N",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "N",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												113.281,
												-71.094
											],
											[
												101.416,
												-71.094
											],
											[
												101.318,
												-22.314
											],
											[
												78.271,
												-71.094
											],
											[
												66.406,
												-71.094
											],
											[
												66.406,
												0
											],
											[
												78.271,
												0
											],
											[
												78.32,
												-48.926
											],
											[
												101.465,
												0
											],
											[
												113.281,
												0
											]
										],
										"c": true
									}
								},
								"nm": "N",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "N",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "G",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												54.883,
												-35.986
											],
											[
												30.566,
												-35.986
											],
											[
												30.566,
												-26.855
											],
											[
												43.408,
												-26.855
											],
											[
												43.311,
												-12.646
											],
											[
												42.041,
												-11.271
											],
											[
												39.314,
												-9.846
											],
											[
												36.084,
												-8.959
											],
											[
												32.6,
												-8.594
											],
											[
												26.481,
												-9.261
											],
											[
												21.07,
												-13.386
											],
											[
												17.732,
												-19.905
											],
											[
												16.292,
												-28.142
											],
											[
												16.26,
												-39.99
											],
											[
												16.585,
												-45.793
											],
											[
												18.555,
												-53.62
											],
											[
												22.371,
												-59.399
											],
											[
												28.044,
												-62.451
											],
											[
												34.285,
												-62.166
											],
											[
												38.509,
												-60.205
											],
											[
												41.422,
												-56.755
											],
											[
												43.115,
												-51.969
											],
											[
												54.932,
												-50.049
											],
											[
												53.833,
												-56.495
											],
											[
												49.739,
												-64.283
											],
											[
												43.083,
												-69.548
											],
											[
												34,
												-72.07
											],
											[
												22.575,
												-71.232
											],
											[
												13.501,
												-65.592
											],
											[
												7.422,
												-56.396
											],
											[
												4.492,
												-44.385
											],
											[
												4.492,
												-31.104
											],
											[
												5.134,
												-22.412
											],
											[
												9.236,
												-11.206
											],
											[
												16.536,
												-3.174
											],
											[
												26.887,
												0.977
											],
											[
												36.335,
												0.732
											],
											[
												43.245,
												-0.928
											],
											[
												49.104,
												-3.727
											],
											[
												53.775,
												-7.454
											]
										],
										"o": [
											[
												54.883,
												-35.986
											],
											[
												30.566,
												-35.986
											],
											[
												30.566,
												-26.855
											],
											[
												43.408,
												-26.855
											],
											[
												42.757,
												-11.897
											],
											[
												40.283,
												-10.262
											],
											[
												37.199,
												-9.195
											],
											[
												33.74,
												-8.667
											],
											[
												28.792,
												-8.626
											],
											[
												22.64,
												-11.735
											],
											[
												18.628,
												-17.521
											],
											[
												16.593,
												-25.309
											],
											[
												16.26,
												-31.104
											],
											[
												16.292,
												-42.952
											],
											[
												17.692,
												-51.229
											],
											[
												20.899,
												-57.755
											],
											[
												25.92,
												-61.841
											],
											[
												32.536,
												-62.451
											],
											[
												37.248,
												-61.027
											],
											[
												40.592,
												-58.057
											],
											[
												42.659,
												-53.695
											],
											[
												43.408,
												-50.049
											],
											[
												54.606,
												-53.434
											],
											[
												51.391,
												-61.963
											],
											[
												45.572,
												-68.091
											],
											[
												37.288,
												-71.566
											],
											[
												26.22,
												-72.07
											],
											[
												16.194,
												-67.879
											],
											[
												9.107,
												-59.797
											],
											[
												5.078,
												-48.584
											],
											[
												4.492,
												-39.893
											],
											[
												4.524,
												-26.612
											],
											[
												7.511,
												-14.6
											],
											[
												13.761,
												-5.444
											],
											[
												23.112,
												0.146
											],
											[
												33.821,
												0.977
											],
											[
												41.056,
												-0.244
											],
											[
												47.282,
												-2.686
											],
											[
												52.359,
												-6.136
											],
											[
												54.98,
												-8.887
											]
										],
										"v": [
											[
												54.883,
												-35.986
											],
											[
												30.566,
												-35.986
											],
											[
												30.566,
												-26.855
											],
											[
												43.408,
												-26.855
											],
											[
												43.311,
												-12.646
											],
											[
												41.162,
												-10.767
											],
											[
												38.257,
												-9.521
											],
											[
												34.912,
												-8.813
											],
											[
												31.494,
												-8.594
											],
											[
												24.561,
												-10.498
											],
											[
												19.849,
												-15.454
											],
											[
												17.163,
												-22.607
											],
											[
												16.26,
												-31.104
											],
											[
												16.26,
												-39.99
											],
											[
												17.139,
												-48.511
											],
											[
												19.727,
												-55.688
											],
											[
												24.146,
												-60.62
											],
											[
												30.518,
												-62.451
											],
											[
												35.767,
												-61.597
											],
											[
												39.551,
												-59.131
											],
											[
												42.041,
												-55.225
											],
											[
												43.408,
												-50.049
											],
											[
												54.932,
												-50.049
											],
											[
												52.612,
												-59.229
											],
											[
												47.656,
												-66.187
											],
											[
												40.186,
												-70.557
											],
											[
												30.322,
												-72.07
											],
											[
												19.385,
												-69.556
											],
											[
												11.304,
												-62.695
											],
											[
												6.25,
												-52.49
											],
											[
												4.492,
												-39.893
											],
											[
												4.492,
												-31.104
											],
											[
												6.323,
												-18.506
											],
											[
												11.499,
												-8.325
											],
											[
												19.824,
												-1.514
											],
											[
												31.152,
												0.977
											],
											[
												38.696,
												0.244
											],
											[
												45.264,
												-1.807
											],
											[
												50.732,
												-4.932
											],
											[
												54.98,
												-8.887
											]
										],
										"c": true
									}
								},
								"nm": "G",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "G",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.879,
												-0.504
											],
											[
												1.057,
												-0.325
											],
											[
												1.172,
												-0.146
											],
											[
												1.106,
												0
											],
											[
												1.92,
												1.237
											],
											[
												1.221,
												2.068
											],
											[
												0.569,
												2.702
											],
											[
												0.032,
												2.962
											],
											[
												0,
												0
											],
											[
												-0.554,
												2.718
											],
											[
												-1.172,
												2.068
											],
											[
												-1.775,
												1.221
											],
											[
												-2.474,
												0
											],
											[
												-1.482,
												-0.569
											],
											[
												-1.042,
												-1.074
											],
											[
												-0.619,
												-1.53
											],
											[
												-0.293,
												-1.92
											],
											[
												0,
												0
											],
											[
												1.221,
												2.734
											],
											[
												2.083,
												1.904
											],
											[
												2.897,
												1.009
											],
											[
												3.678,
												0
											],
											[
												3.19,
												-1.676
											],
											[
												2.197,
												-2.897
											],
											[
												1.172,
												-3.906
											],
											[
												0,
												-4.492
											],
											[
												0,
												0
											],
											[
												-1.189,
												-3.906
											],
											[
												-2.263,
												-2.881
											],
											[
												-3.288,
												-1.66
											],
											[
												-4.265,
												0
											],
											[
												-2.361,
												0.488
											],
											[
												-2.019,
												0.879
											],
											[
												-1.628,
												1.205
											],
											[
												-1.205,
												1.433
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.554,
												0.749
											],
											[
												-0.879,
												0.505
											],
											[
												-1.058,
												0.326
											],
											[
												-1.172,
												0.146
											],
											[
												-2.702,
												-0.032
											],
											[
												-1.921,
												-1.237
											],
											[
												-1.221,
												-2.067
											],
											[
												-0.57,
												-2.702
											],
											[
												0,
												0
											],
											[
												0.032,
												-2.962
											],
											[
												0.553,
												-2.718
											],
											[
												1.172,
												-2.067
											],
											[
												1.774,
												-1.221
											],
											[
												2.018,
												0
											],
											[
												1.481,
												0.57
											],
											[
												1.041,
												1.074
											],
											[
												0.618,
												1.53
											],
											[
												0,
												0
											],
											[
												-0.326,
												-3.385
											],
											[
												-1.221,
												-2.734
											],
											[
												-2.084,
												-1.904
											],
											[
												-2.898,
												-1.009
											],
											[
												-4.102,
												0
											],
											[
												-3.191,
												1.677
											],
											[
												-2.197,
												2.898
											],
											[
												-1.172,
												3.906
											],
											[
												0,
												0
											],
											[
												0.032,
												4.492
											],
											[
												1.188,
												3.906
											],
											[
												2.262,
												2.881
											],
											[
												3.288,
												1.66
											],
											[
												2.669,
												0
											],
											[
												2.36,
												-0.488
											],
											[
												2.018,
												-0.879
											],
											[
												1.627,
												-1.204
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												114.893,
												-35.986
											],
											[
												90.576,
												-35.986
											],
											[
												90.576,
												-26.855
											],
											[
												103.418,
												-26.855
											],
											[
												103.32,
												-12.646
											],
											[
												101.172,
												-10.767
											],
											[
												98.267,
												-9.521
											],
											[
												94.922,
												-8.813
											],
											[
												91.504,
												-8.594
											],
											[
												84.57,
												-10.498
											],
											[
												79.858,
												-15.454
											],
											[
												77.173,
												-22.607
											],
											[
												76.27,
												-31.104
											],
											[
												76.27,
												-39.99
											],
											[
												77.148,
												-48.511
											],
											[
												79.736,
												-55.688
											],
											[
												84.155,
												-60.62
											],
											[
												90.527,
												-62.451
											],
											[
												95.776,
												-61.597
											],
											[
												99.561,
												-59.131
											],
											[
												102.051,
												-55.225
											],
											[
												103.418,
												-50.049
											],
											[
												114.941,
												-50.049
											],
											[
												112.622,
												-59.229
											],
											[
												107.666,
												-66.187
											],
											[
												100.195,
												-70.557
											],
											[
												90.332,
												-72.07
											],
											[
												79.395,
												-69.556
											],
											[
												71.313,
												-62.695
											],
											[
												66.26,
												-52.49
											],
											[
												64.502,
												-39.893
											],
											[
												64.502,
												-31.104
											],
											[
												66.333,
												-18.506
											],
											[
												71.509,
												-8.325
											],
											[
												79.834,
												-1.514
											],
											[
												91.162,
												0.977
											],
											[
												98.706,
												0.244
											],
											[
												105.273,
												-1.807
											],
											[
												110.742,
												-4.932
											],
											[
												114.99,
												-8.887
											]
										],
										"c": true
									}
								},
								"nm": "G",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "G",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "L",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												20.117,
												-71.094
											],
											[
												8.398,
												-71.094
											],
											[
												8.398,
												0
											],
											[
												54.004,
												0
											],
											[
												54.004,
												-9.57
											],
											[
												20.117,
												-9.57
											]
										],
										"o": [
											[
												20.117,
												-71.094
											],
											[
												8.398,
												-71.094
											],
											[
												8.398,
												0
											],
											[
												54.004,
												0
											],
											[
												54.004,
												-9.57
											],
											[
												20.117,
												-9.57
											]
										],
										"v": [
											[
												20.117,
												-71.094
											],
											[
												8.398,
												-71.094
											],
											[
												8.398,
												0
											],
											[
												54.004,
												0
											],
											[
												54.004,
												-9.57
											],
											[
												20.117,
												-9.57
											]
										],
										"c": true
									}
								},
								"nm": "L",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "L",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												80.127,
												-71.094
											],
											[
												68.408,
												-71.094
											],
											[
												68.408,
												0
											],
											[
												114.014,
												0
											],
											[
												114.014,
												-9.57
											],
											[
												80.127,
												-9.57
											]
										],
										"c": true
									}
								},
								"nm": "L",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "L",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": " ",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "O",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												55.469,
												-40.039
											],
											[
												54.931,
												-48.274
											],
											[
												51.171,
												-59.432
											],
											[
												44.197,
												-67.676
											],
											[
												34.033,
												-72.07
											],
											[
												24.308,
												-71.663
											],
											[
												17.472,
												-68.912
											],
											[
												12.101,
												-64.331
											],
											[
												8.179,
												-58.146
											],
											[
												5.622,
												-50.911
											],
											[
												4.443,
												-42.838
											],
											[
												4.443,
												-30.957
											],
											[
												4.972,
												-22.737
											],
											[
												8.667,
												-11.662
											],
											[
												15.494,
												-3.418
											],
											[
												25.52,
												0.977
											],
											[
												37.833,
												0.105
											],
											[
												46.916,
												-5.721
											],
											[
												52.783,
												-15.015
											],
											[
												55.469,
												-26.758
											]
										],
										"o": [
											[
												55.469,
												-44.238
											],
											[
												52.783,
												-56.021
											],
											[
												46.875,
												-65.324
											],
											[
												37.784,
												-71.192
											],
											[
												26.904,
												-72.07
											],
											[
												19.587,
												-70.036
											],
											[
												13.729,
												-66.047
											],
											[
												9.334,
												-60.327
											],
											[
												6.323,
												-53.425
											],
											[
												4.679,
												-45.572
											],
											[
												4.443,
												-40.039
											],
											[
												4.443,
												-26.758
											],
											[
												7.087,
												-15.055
											],
											[
												12.867,
												-5.77
											],
											[
												21.809,
												0.098
											],
											[
												34.082,
												0.977
											],
											[
												44.246,
												-3.377
											],
											[
												51.18,
												-11.613
											],
											[
												54.931,
												-22.729
											],
											[
												55.469,
												-30.957
											]
										],
										"v": [
											[
												55.469,
												-40.039
											],
											[
												53.857,
												-52.148
											],
											[
												49.023,
												-62.378
											],
											[
												40.991,
												-69.434
											],
											[
												29.736,
												-72.07
											],
											[
												21.948,
												-70.85
											],
											[
												15.601,
												-67.48
											],
											[
												10.718,
												-62.329
											],
											[
												7.251,
												-55.786
											],
											[
												5.151,
												-48.242
											],
											[
												4.443,
												-40.039
											],
											[
												4.443,
												-30.957
											],
											[
												6.03,
												-18.896
											],
											[
												10.767,
												-8.716
											],
											[
												18.652,
												-1.66
											],
											[
												29.785,
												0.977
											],
											[
												41.04,
												-1.636
											],
											[
												49.048,
												-8.667
											],
											[
												53.857,
												-18.872
											],
											[
												55.469,
												-30.957
											]
										],
										"c": true
									}
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												43.701,
												-30.957
											],
											[
												43.432,
												-25.635
											],
											[
												41.797,
												-18.001
											],
											[
												38.224,
												-12.142
											],
											[
												32.454,
												-8.887
											],
											[
												24.959,
												-9.538
											],
											[
												20.092,
												-13.842
											],
											[
												17.318,
												-20.401
											],
											[
												16.243,
												-28.287
											],
											[
												16.211,
												-40.137
											],
											[
												16.463,
												-45.45
											],
											[
												17.994,
												-53.043
											],
											[
												21.427,
												-58.895
											],
											[
												27.099,
												-62.109
											],
											[
												34.626,
												-61.467
											],
											[
												39.6,
												-57.218
											],
											[
												42.513,
												-50.733
											],
											[
												43.668,
												-42.806
											]
										],
										"o": [
											[
												43.668,
												-28.287
											],
											[
												42.554,
												-20.361
											],
											[
												39.649,
												-13.834
											],
											[
												34.675,
												-9.538
											],
											[
												27.148,
												-8.887
											],
											[
												21.476,
												-12.142
											],
											[
												18.042,
												-18.042
											],
											[
												16.472,
												-25.642
											],
											[
												16.211,
												-30.957
											],
											[
												16.243,
												-42.806
											],
											[
												17.277,
												-50.691
											],
											[
												20.044,
												-57.21
											],
											[
												24.91,
												-61.467
											],
											[
												32.405,
												-62.109
											],
											[
												38.175,
												-58.895
											],
											[
												41.748,
												-53.083
											],
											[
												43.424,
												-45.459
											],
											[
												43.701,
												-40.137
											]
										],
										"v": [
											[
												43.701,
												-30.957
											],
											[
												42.993,
												-22.998
											],
											[
												40.723,
												-15.918
											],
											[
												36.45,
												-10.84
											],
											[
												29.785,
												-8.887
											],
											[
												23.218,
												-10.84
											],
											[
												19.067,
												-15.942
											],
											[
												16.895,
												-23.022
											],
											[
												16.211,
												-30.957
											],
											[
												16.211,
												-40.137
											],
											[
												16.87,
												-48.071
											],
											[
												19.019,
												-55.127
											],
											[
												23.169,
												-60.181
											],
											[
												29.736,
												-62.109
											],
											[
												36.401,
												-60.181
											],
											[
												40.674,
												-55.151
											],
											[
												42.969,
												-48.096
											],
											[
												43.701,
												-40.137
											]
										],
										"c": true
									}
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "O",
						"np": 5,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												1.074,
												3.874
											],
											[
												2.148,
												2.946
											],
											[
												3.206,
												1.758
											],
											[
												4.297,
												0
											],
											[
												2.36,
												-0.813
											],
											[
												1.871,
												-1.432
											],
											[
												1.383,
												-2.002
											],
											[
												0.928,
												-2.36
											],
											[
												0.471,
												-2.669
											],
											[
												0,
												-2.799
											],
											[
												0,
												0
											],
											[
												-1.058,
												-3.841
											],
											[
												-2.1,
												-2.946
											],
											[
												-3.158,
												-1.758
											],
											[
												-4.265,
												0
											],
											[
												-3.207,
												1.741
											],
											[
												-2.132,
												2.946
											],
											[
												-1.074,
												3.857
											],
											[
												0,
												4.199
											]
										],
										"o": [
											[
												0,
												-4.199
											],
											[
												-1.074,
												-3.873
											],
											[
												-2.148,
												-2.946
											],
											[
												-3.207,
												-1.758
											],
											[
												-2.832,
												0
											],
											[
												-2.361,
												0.814
											],
											[
												-1.872,
												1.433
											],
											[
												-1.384,
												2.002
											],
											[
												-0.928,
												2.361
											],
											[
												-0.472,
												2.67
											],
											[
												0,
												0
											],
											[
												0,
												4.199
											],
											[
												1.057,
												3.841
											],
											[
												2.1,
												2.946
											],
											[
												3.157,
												1.758
											],
											[
												4.297,
												0
											],
											[
												3.206,
												-1.741
											],
											[
												2.132,
												-2.946
											],
											[
												1.074,
												-3.857
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												115.479,
												-40.039
											],
											[
												113.867,
												-52.148
											],
											[
												109.033,
												-62.378
											],
											[
												101.001,
												-69.434
											],
											[
												89.746,
												-72.07
											],
											[
												81.958,
												-70.85
											],
											[
												75.61,
												-67.48
											],
											[
												70.728,
												-62.329
											],
											[
												67.261,
												-55.786
											],
											[
												65.161,
												-48.242
											],
											[
												64.453,
												-40.039
											],
											[
												64.453,
												-30.957
											],
											[
												66.04,
												-18.896
											],
											[
												70.776,
												-8.716
											],
											[
												78.662,
												-1.66
											],
											[
												89.795,
												0.977
											],
											[
												101.05,
												-1.636
											],
											[
												109.058,
												-8.667
											],
											[
												113.867,
												-18.872
											],
											[
												115.479,
												-30.957
											]
										],
										"c": true
									}
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0.439,
												-2.637
											],
											[
												1.074,
												-2.083
											],
											[
												1.774,
												-1.302
											],
											[
												2.669,
												0
											],
											[
												1.741,
												1.302
											],
											[
												1.025,
												2.1
											],
											[
												0.423,
												2.621
											],
											[
												0.032,
												2.67
											],
											[
												0,
												0
											],
											[
												-0.407,
												2.621
											],
											[
												-1.025,
												2.084
											],
											[
												-1.742,
												1.286
											],
											[
												-2.637,
												0
											],
											[
												-1.775,
												-1.286
											],
											[
												-1.074,
												-2.067
											],
											[
												-0.456,
												-2.637
											],
											[
												-0.033,
												-2.669
											]
										],
										"o": [
											[
												-0.033,
												2.67
											],
											[
												-0.439,
												2.637
											],
											[
												-1.074,
												2.084
											],
											[
												-1.775,
												1.302
											],
											[
												-2.637,
												0
											],
											[
												-1.742,
												-1.302
											],
											[
												-1.025,
												-2.1
											],
											[
												-0.423,
												-2.62
											],
											[
												0,
												0
											],
											[
												0.032,
												-2.669
											],
											[
												0.407,
												-2.62
											],
											[
												1.025,
												-2.083
											],
											[
												1.741,
												-1.286
											],
											[
												2.669,
												0
											],
											[
												1.774,
												1.286
											],
											[
												1.074,
												2.068
											],
											[
												0.455,
												2.637
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												103.711,
												-30.957
											],
											[
												103.003,
												-22.998
											],
											[
												100.732,
												-15.918
											],
											[
												96.46,
												-10.84
											],
											[
												89.795,
												-8.887
											],
											[
												83.228,
												-10.84
											],
											[
												79.077,
												-15.942
											],
											[
												76.904,
												-23.022
											],
											[
												76.221,
												-30.957
											],
											[
												76.221,
												-40.137
											],
											[
												76.88,
												-48.071
											],
											[
												79.028,
												-55.127
											],
											[
												83.179,
												-60.181
											],
											[
												89.746,
												-62.109
											],
											[
												96.411,
												-60.181
											],
											[
												100.684,
												-55.151
											],
											[
												102.979,
												-48.096
											],
											[
												103.711,
												-40.137
											]
										],
										"c": true
									}
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "O",
						"np": 5,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "A",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												46.533,
												0
											],
											[
												58.594,
												0
											],
											[
												35.938,
												-71.094
											],
											[
												25.635,
												-71.094
											],
											[
												2.539,
												0
											],
											[
												14.648,
												0
											],
											[
												19.531,
												-16.504
											],
											[
												41.748,
												-16.504
											]
										],
										"o": [
											[
												46.533,
												0
											],
											[
												58.594,
												0
											],
											[
												35.938,
												-71.094
											],
											[
												25.635,
												-71.094
											],
											[
												2.539,
												0
											],
											[
												14.648,
												0
											],
											[
												19.531,
												-16.504
											],
											[
												41.748,
												-16.504
											]
										],
										"v": [
											[
												46.533,
												0
											],
											[
												58.594,
												0
											],
											[
												35.938,
												-71.094
											],
											[
												25.635,
												-71.094
											],
											[
												2.539,
												0
											],
											[
												14.648,
												0
											],
											[
												19.531,
												-16.504
											],
											[
												41.748,
												-16.504
											]
										],
										"c": true
									}
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												30.762,
												-54.395
											],
											[
												38.818,
												-26.514
											],
											[
												22.51,
												-26.514
											]
										],
										"o": [
											[
												30.762,
												-54.395
											],
											[
												38.818,
												-26.514
											],
											[
												22.51,
												-26.514
											]
										],
										"v": [
											[
												30.762,
												-54.395
											],
											[
												38.818,
												-26.514
											],
											[
												22.51,
												-26.514
											]
										],
										"c": true
									}
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "A",
						"np": 5,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												106.543,
												0
											],
											[
												118.604,
												0
											],
											[
												95.947,
												-71.094
											],
											[
												85.645,
												-71.094
											],
											[
												62.549,
												0
											],
											[
												74.658,
												0
											],
											[
												79.541,
												-16.504
											],
											[
												101.758,
												-16.504
											]
										],
										"c": true
									}
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												90.771,
												-54.395
											],
											[
												98.828,
												-26.514
											],
											[
												82.52,
												-26.514
											]
										],
										"c": true
									}
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "A",
						"np": 5,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "V",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												15.186,
												-71.094
											],
											[
												2.393,
												-71.094
											],
											[
												24.316,
												0
											],
											[
												35.498,
												0
											],
											[
												57.471,
												-71.094
											],
											[
												44.678,
												-71.094
											],
											[
												29.883,
												-17.822
											]
										],
										"o": [
											[
												15.186,
												-71.094
											],
											[
												2.393,
												-71.094
											],
											[
												24.316,
												0
											],
											[
												35.498,
												0
											],
											[
												57.471,
												-71.094
											],
											[
												44.678,
												-71.094
											],
											[
												29.883,
												-17.822
											]
										],
										"v": [
											[
												15.186,
												-71.094
											],
											[
												2.393,
												-71.094
											],
											[
												24.316,
												0
											],
											[
												35.498,
												0
											],
											[
												57.471,
												-71.094
											],
											[
												44.678,
												-71.094
											],
											[
												29.883,
												-17.822
											]
										],
										"c": true
									}
								},
								"nm": "V",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "V",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												75.195,
												-71.094
											],
											[
												62.402,
												-71.094
											],
											[
												84.326,
												0
											],
											[
												95.508,
												0
											],
											[
												117.48,
												-71.094
											],
											[
												104.688,
												-71.094
											],
											[
												89.893,
												-17.822
											]
										],
										"c": true
									}
								},
								"nm": "V",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "V",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "M",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												6.592,
												-71.094
											],
											[
												6.592,
												0
											],
											[
												17.627,
												0
											],
											[
												17.627,
												-24.414
											],
											[
												16.943,
												-54.395
											],
											[
												26.855,
												-21.484
											],
											[
												33.008,
												-21.484
											],
											[
												43.945,
												-55.566
											],
											[
												43.262,
												-24.414
											],
											[
												43.262,
												0
											],
											[
												54.297,
												0
											],
											[
												54.297,
												-71.094
											],
											[
												39.746,
												-71.094
											],
											[
												29.98,
												-40.381
											],
											[
												21.143,
												-71.094
											]
										],
										"o": [
											[
												6.592,
												-71.094
											],
											[
												6.592,
												0
											],
											[
												17.627,
												0
											],
											[
												17.627,
												-24.414
											],
											[
												16.943,
												-54.395
											],
											[
												26.855,
												-21.484
											],
											[
												33.008,
												-21.484
											],
											[
												43.945,
												-55.566
											],
											[
												43.262,
												-24.414
											],
											[
												43.262,
												0
											],
											[
												54.297,
												0
											],
											[
												54.297,
												-71.094
											],
											[
												39.746,
												-71.094
											],
											[
												29.98,
												-40.381
											],
											[
												21.143,
												-71.094
											]
										],
										"v": [
											[
												6.592,
												-71.094
											],
											[
												6.592,
												0
											],
											[
												17.627,
												0
											],
											[
												17.627,
												-24.414
											],
											[
												16.943,
												-54.395
											],
											[
												26.855,
												-21.484
											],
											[
												33.008,
												-21.484
											],
											[
												43.945,
												-55.566
											],
											[
												43.262,
												-24.414
											],
											[
												43.262,
												0
											],
											[
												54.297,
												0
											],
											[
												54.297,
												-71.094
											],
											[
												39.746,
												-71.094
											],
											[
												29.98,
												-40.381
											],
											[
												21.143,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "M",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "M",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												66.602,
												-71.094
											],
											[
												66.602,
												0
											],
											[
												77.637,
												0
											],
											[
												77.637,
												-24.414
											],
											[
												76.953,
												-54.395
											],
											[
												86.865,
												-21.484
											],
											[
												93.018,
												-21.484
											],
											[
												103.955,
												-55.566
											],
											[
												103.271,
												-24.414
											],
											[
												103.271,
												0
											],
											[
												114.307,
												0
											],
											[
												114.307,
												-71.094
											],
											[
												99.756,
												-71.094
											],
											[
												89.99,
												-40.381
											],
											[
												81.152,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "M",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "M",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "Z",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												53.516,
												-63.379
											],
											[
												53.467,
												-71.094
											],
											[
												5.176,
												-71.094
											],
											[
												5.176,
												-61.426
											],
											[
												39.648,
												-61.426
											],
											[
												4.883,
												-7.91
											],
											[
												4.932,
												0
											],
											[
												54.59,
												0
											],
											[
												54.59,
												-9.57
											],
											[
												18.701,
												-9.57
											]
										],
										"o": [
											[
												53.516,
												-63.379
											],
											[
												53.467,
												-71.094
											],
											[
												5.176,
												-71.094
											],
											[
												5.176,
												-61.426
											],
											[
												39.648,
												-61.426
											],
											[
												4.883,
												-7.91
											],
											[
												4.932,
												0
											],
											[
												54.59,
												0
											],
											[
												54.59,
												-9.57
											],
											[
												18.701,
												-9.57
											]
										],
										"v": [
											[
												53.516,
												-63.379
											],
											[
												53.467,
												-71.094
											],
											[
												5.176,
												-71.094
											],
											[
												5.176,
												-61.426
											],
											[
												39.648,
												-61.426
											],
											[
												4.883,
												-7.91
											],
											[
												4.932,
												0
											],
											[
												54.59,
												0
											],
											[
												54.59,
												-9.57
											],
											[
												18.701,
												-9.57
											]
										],
										"c": true
									}
								},
								"nm": "Z",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "Z",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												113.525,
												-63.379
											],
											[
												113.477,
												-71.094
											],
											[
												65.186,
												-71.094
											],
											[
												65.186,
												-61.426
											],
											[
												99.658,
												-61.426
											],
											[
												64.893,
												-7.91
											],
											[
												64.941,
												0
											],
											[
												114.6,
												0
											],
											[
												114.6,
												-9.57
											],
											[
												78.711,
												-9.57
											]
										],
										"c": true
									}
								},
								"nm": "Z",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "Z",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "K",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												45.703,
												0
											],
											[
												59.766,
												0
											],
											[
												34.375,
												-39.893
											],
											[
												58.545,
												-71.094
											],
											[
												44.238,
												-71.094
											],
											[
												25.537,
												-46.24
											],
											[
												19.043,
												-37.793
											],
											[
												19.043,
												-71.094
											],
											[
												7.178,
												-71.094
											],
											[
												7.178,
												0
											],
											[
												19.043,
												0
											],
											[
												19.043,
												-22.363
											],
											[
												26.66,
												-30.908
											]
										],
										"o": [
											[
												45.703,
												0
											],
											[
												59.766,
												0
											],
											[
												34.375,
												-39.893
											],
											[
												58.545,
												-71.094
											],
											[
												44.238,
												-71.094
											],
											[
												25.537,
												-46.24
											],
											[
												19.043,
												-37.793
											],
											[
												19.043,
												-71.094
											],
											[
												7.178,
												-71.094
											],
											[
												7.178,
												0
											],
											[
												19.043,
												0
											],
											[
												19.043,
												-22.363
											],
											[
												26.66,
												-30.908
											]
										],
										"v": [
											[
												45.703,
												0
											],
											[
												59.766,
												0
											],
											[
												34.375,
												-39.893
											],
											[
												58.545,
												-71.094
											],
											[
												44.238,
												-71.094
											],
											[
												25.537,
												-46.24
											],
											[
												19.043,
												-37.793
											],
											[
												19.043,
												-71.094
											],
											[
												7.178,
												-71.094
											],
											[
												7.178,
												0
											],
											[
												19.043,
												0
											],
											[
												19.043,
												-22.363
											],
											[
												26.66,
												-30.908
											]
										],
										"c": true
									}
								},
								"nm": "K",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "K",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												105.713,
												0
											],
											[
												119.775,
												0
											],
											[
												94.385,
												-39.893
											],
											[
												118.555,
												-71.094
											],
											[
												104.248,
												-71.094
											],
											[
												85.547,
												-46.24
											],
											[
												79.053,
												-37.793
											],
											[
												79.053,
												-71.094
											],
											[
												67.188,
												-71.094
											],
											[
												67.188,
												0
											],
											[
												79.053,
												0
											],
											[
												79.053,
												-22.363
											],
											[
												86.67,
												-30.908
											]
										],
										"c": true
									}
								},
								"nm": "K",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "K",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "D",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												24.414,
												0
											],
											[
												33.513,
												-0.798
											],
											[
												44.466,
												-6.225
											],
											[
												51.953,
												-15.437
											],
											[
												55.631,
												-27.929
											],
											[
												55.664,
												-38.184
											],
											[
												54.883,
												-47.517
											],
											[
												49.862,
												-59.016
											],
											[
												41.12,
												-67.057
											],
											[
												28.955,
												-71.061
											],
											[
												6.689,
												-71.094
											],
											[
												6.689,
												0
											]
										],
										"o": [
											[
												29.199,
												0
											],
											[
												41.195,
												-3.988
											],
											[
												49.87,
												-11.987
											],
											[
												54.883,
												-23.478
											],
											[
												55.664,
												-32.812
											],
											[
												55.631,
												-43.067
											],
											[
												51.953,
												-55.558
											],
											[
												44.426,
												-64.811
											],
											[
												33.341,
												-70.247
											],
											[
												24.072,
												-71.094
											],
											[
												6.689,
												-71.094
											],
											[
												6.689,
												0
											]
										],
										"v": [
											[
												24.414,
												0
											],
											[
												37.354,
												-2.393
											],
											[
												47.168,
												-9.106
											],
											[
												53.418,
												-19.458
											],
											[
												55.664,
												-32.812
											],
											[
												55.664,
												-38.184
											],
											[
												53.418,
												-51.538
											],
											[
												47.144,
												-61.914
											],
											[
												37.231,
												-68.652
											],
											[
												24.072,
												-71.094
											],
											[
												6.689,
												-71.094
											],
											[
												6.689,
												0
											]
										],
										"c": true
									}
								},
								"nm": "D",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												24.072,
												-61.621
											],
											[
												30.281,
												-60.994
											],
											[
												37.239,
												-57.072
											],
											[
												41.707,
												-50.488
											],
											[
												43.717,
												-41.699
											],
											[
												43.75,
												-32.812
											],
											[
												43.302,
												-26.106
											],
											[
												40.503,
												-17.928
											],
											[
												35.27,
												-12.28
											],
											[
												27.637,
												-9.456
											],
											[
												18.604,
												-9.424
											],
											[
												18.604,
												-61.621
											]
										],
										"o": [
											[
												27.392,
												-61.588
											],
											[
												35.196,
												-58.683
											],
											[
												40.494,
												-52.937
											],
											[
												43.302,
												-44.824
											],
											[
												43.75,
												-38.281
											],
											[
												43.717,
												-29.296
											],
											[
												41.707,
												-20.377
											],
											[
												37.281,
												-13.859
											],
											[
												30.452,
												-10.034
											],
											[
												24.414,
												-9.424
											],
											[
												18.604,
												-9.424
											],
											[
												18.604,
												-61.621
											]
										],
										"v": [
											[
												24.072,
												-61.621
											],
											[
												32.739,
												-59.839
											],
											[
												38.867,
												-55.005
											],
											[
												42.505,
												-47.656
											],
											[
												43.75,
												-38.281
											],
											[
												43.75,
												-32.812
											],
											[
												42.505,
												-23.242
											],
											[
												38.892,
												-15.894
											],
											[
												32.861,
												-11.157
											],
											[
												24.414,
												-9.424
											],
											[
												18.604,
												-9.424
											],
											[
												18.604,
												-61.621
											]
										],
										"c": true
									}
								},
								"nm": "D",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "D",
						"np": 5,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												-3.841,
												1.595
											],
											[
												-2.702,
												2.881
											],
											[
												-1.465,
												4.021
											],
											[
												-0.033,
												4.883
											],
											[
												0,
												0
											],
											[
												1.465,
												4.021
											],
											[
												2.718,
												2.898
											],
											[
												3.889,
												1.595
											],
											[
												4.883,
												0.033
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												4.785,
												0
											],
											[
												3.841,
												-1.595
											],
											[
												2.702,
												-2.881
											],
											[
												1.465,
												-4.02
											],
											[
												0,
												0
											],
											[
												-0.033,
												-4.883
											],
											[
												-1.465,
												-4.02
											],
											[
												-2.718,
												-2.897
											],
											[
												-3.89,
												-1.595
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												84.424,
												0
											],
											[
												97.363,
												-2.393
											],
											[
												107.178,
												-9.106
											],
											[
												113.428,
												-19.458
											],
											[
												115.674,
												-32.812
											],
											[
												115.674,
												-38.184
											],
											[
												113.428,
												-51.538
											],
											[
												107.153,
												-61.914
											],
											[
												97.241,
												-68.652
											],
											[
												84.082,
												-71.094
											],
											[
												66.699,
												-71.094
											],
											[
												66.699,
												0
											]
										],
										"c": true
									}
								},
								"nm": "D",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												-2.458,
												-1.155
											],
											[
												-1.628,
												-2.067
											],
											[
												-0.798,
												-2.832
											],
											[
												-0.033,
												-3.418
											],
											[
												0,
												0
											],
											[
												0.797,
												-2.864
											],
											[
												1.611,
												-2.034
											],
											[
												2.409,
												-1.123
											],
											[
												3.223,
												-0.032
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												3.32,
												0.033
											],
											[
												2.457,
												1.156
											],
											[
												1.627,
												2.068
											],
											[
												0.797,
												2.832
											],
											[
												0,
												0
											],
											[
												-0.033,
												3.516
											],
											[
												-0.798,
												2.865
											],
											[
												-1.611,
												2.035
											],
											[
												-2.409,
												1.123
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												84.082,
												-61.621
											],
											[
												92.749,
												-59.839
											],
											[
												98.877,
												-55.005
											],
											[
												102.515,
												-47.656
											],
											[
												103.76,
												-38.281
											],
											[
												103.76,
												-32.812
											],
											[
												102.515,
												-23.242
											],
											[
												98.901,
												-15.894
											],
											[
												92.871,
												-11.157
											],
											[
												84.424,
												-9.424
											],
											[
												78.613,
												-9.424
											],
											[
												78.613,
												-61.621
											]
										],
										"c": true
									}
								},
								"nm": "D",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "D",
						"np": 5,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "F",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												49.854,
												-39.893
											],
											[
												20.02,
												-39.893
											],
											[
												20.02,
												-61.426
											],
											[
												54.248,
												-61.426
											],
											[
												54.248,
												-71.094
											],
											[
												8.203,
												-71.094
											],
											[
												8.203,
												0
											],
											[
												20.02,
												0
											],
											[
												20.02,
												-30.273
											],
											[
												49.854,
												-30.273
											]
										],
										"o": [
											[
												49.854,
												-39.893
											],
											[
												20.02,
												-39.893
											],
											[
												20.02,
												-61.426
											],
											[
												54.248,
												-61.426
											],
											[
												54.248,
												-71.094
											],
											[
												8.203,
												-71.094
											],
											[
												8.203,
												0
											],
											[
												20.02,
												0
											],
											[
												20.02,
												-30.273
											],
											[
												49.854,
												-30.273
											]
										],
										"v": [
											[
												49.854,
												-39.893
											],
											[
												20.02,
												-39.893
											],
											[
												20.02,
												-61.426
											],
											[
												54.248,
												-61.426
											],
											[
												54.248,
												-71.094
											],
											[
												8.203,
												-71.094
											],
											[
												8.203,
												0
											],
											[
												20.02,
												0
											],
											[
												20.02,
												-30.273
											],
											[
												49.854,
												-30.273
											]
										],
										"c": true
									}
								},
								"nm": "F",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "F",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												109.863,
												-39.893
											],
											[
												80.029,
												-39.893
											],
											[
												80.029,
												-61.426
											],
											[
												114.258,
												-61.426
											],
											[
												114.258,
												-71.094
											],
											[
												68.213,
												-71.094
											],
											[
												68.213,
												0
											],
											[
												80.029,
												0
											],
											[
												80.029,
												-30.273
											],
											[
												109.863,
												-30.273
											]
										],
										"c": true
									}
								},
								"nm": "F",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "F",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "P",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												31.934,
												-27.246
											],
											[
												38.761,
												-27.8
											],
											[
												47.38,
												-31.266
											],
											[
												53.442,
												-37.32
											],
											[
												56.494,
												-45.655
											],
											[
												55.884,
												-55.461
											],
											[
												51.741,
												-63.208
											],
											[
												44.783,
												-68.482
											],
											[
												35.482,
												-71.061
											],
											[
												8.154,
												-71.094
											],
											[
												8.154,
												0
											],
											[
												19.873,
												0
											],
											[
												19.873,
												-27.246
											]
										],
										"o": [
											[
												35.482,
												-27.278
											],
											[
												44.783,
												-29.818
											],
											[
												51.741,
												-35.042
											],
											[
												55.884,
												-42.659
											],
											[
												56.494,
												-52.393
											],
											[
												53.442,
												-60.897
											],
											[
												47.38,
												-67.016
											],
											[
												38.761,
												-70.532
											],
											[
												31.934,
												-71.094
											],
											[
												8.154,
												-71.094
											],
											[
												8.154,
												0
											],
											[
												19.873,
												0
											],
											[
												19.873,
												-27.246
											]
										],
										"v": [
											[
												31.934,
												-27.246
											],
											[
												41.772,
												-28.809
											],
											[
												49.561,
												-33.154
											],
											[
												54.663,
												-39.99
											],
											[
												56.494,
												-48.975
											],
											[
												54.663,
												-58.179
											],
											[
												49.561,
												-65.112
											],
											[
												41.772,
												-69.507
											],
											[
												31.934,
												-71.094
											],
											[
												8.154,
												-71.094
											],
											[
												8.154,
												0
											],
											[
												19.873,
												0
											],
											[
												19.873,
												-27.246
											]
										],
										"c": true
									}
								},
								"nm": "P",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												19.873,
												-61.621
											],
											[
												31.934,
												-61.621
											],
											[
												35.694,
												-61.263
											],
											[
												40.153,
												-59.155
											],
											[
												43.213,
												-55.566
											],
											[
												44.678,
												-50.732
											],
											[
												44.385,
												-45.491
											],
											[
												42.366,
												-41.211
											],
											[
												38.818,
												-38.224
											],
											[
												33.919,
												-36.719
											],
											[
												19.873,
												-36.719
											]
										],
										"o": [
											[
												19.873,
												-61.621
											],
											[
												33.919,
												-61.588
											],
											[
												38.818,
												-60.026
											],
											[
												42.366,
												-56.909
											],
											[
												44.385,
												-52.442
											],
											[
												44.678,
												-47.119
											],
											[
												43.213,
												-42.496
											],
											[
												40.153,
												-39.063
											],
											[
												35.694,
												-37.019
											],
											[
												31.934,
												-36.719
											],
											[
												19.873,
												-36.719
											]
										],
										"v": [
											[
												19.873,
												-61.621
											],
											[
												31.934,
												-61.621
											],
											[
												37.256,
												-60.645
											],
											[
												41.26,
												-58.032
											],
											[
												43.799,
												-54.004
											],
											[
												44.678,
												-48.877
											],
											[
												43.799,
												-43.994
											],
											[
												41.26,
												-40.137
											],
											[
												37.256,
												-37.622
											],
											[
												31.934,
												-36.719
											],
											[
												19.873,
												-36.719
											]
										],
										"c": true
									}
								},
								"nm": "P",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "P",
						"np": 5,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												-3.011,
												1.009
											],
											[
												-2.181,
												1.888
											],
											[
												-1.221,
												2.67
											],
											[
												0,
												3.32
											],
											[
												1.221,
												2.718
											],
											[
												2.18,
												1.904
											],
											[
												3.011,
												1.025
											],
											[
												3.548,
												0.033
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												3.548,
												-0.032
											],
											[
												3.011,
												-1.009
											],
											[
												2.18,
												-1.888
											],
											[
												1.221,
												-2.669
											],
											[
												0,
												-3.418
											],
											[
												-1.221,
												-2.718
											],
											[
												-2.181,
												-1.904
											],
											[
												-3.011,
												-1.025
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												91.943,
												-27.246
											],
											[
												101.782,
												-28.809
											],
											[
												109.57,
												-33.154
											],
											[
												114.673,
												-39.99
											],
											[
												116.504,
												-48.975
											],
											[
												114.673,
												-58.179
											],
											[
												109.57,
												-65.112
											],
											[
												101.782,
												-69.507
											],
											[
												91.943,
												-71.094
											],
											[
												68.164,
												-71.094
											],
											[
												68.164,
												0
											],
											[
												79.883,
												0
											],
											[
												79.883,
												-27.246
											]
										],
										"c": true
									}
								},
								"nm": "P",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.562,
												-0.618
											],
											[
												-1.107,
												-1.123
											],
											[
												-0.586,
												-1.562
											],
											[
												0,
												-1.855
											],
											[
												0.586,
												-1.497
											],
											[
												1.106,
												-1.074
											],
											[
												1.562,
												-0.602
											],
											[
												1.985,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												1.985,
												0.033
											],
											[
												1.562,
												0.619
											],
											[
												1.106,
												1.123
											],
											[
												0.586,
												1.562
											],
											[
												0,
												1.758
											],
											[
												-0.586,
												1.498
											],
											[
												-1.107,
												1.074
											],
											[
												-1.562,
												0.603
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												79.883,
												-61.621
											],
											[
												91.943,
												-61.621
											],
											[
												97.266,
												-60.645
											],
											[
												101.27,
												-58.032
											],
											[
												103.809,
												-54.004
											],
											[
												104.688,
												-48.877
											],
											[
												103.809,
												-43.994
											],
											[
												101.27,
												-40.137
											],
											[
												97.266,
												-37.622
											],
											[
												91.943,
												-36.719
											],
											[
												79.883,
												-36.719
											]
										],
										"c": true
									}
								},
								"nm": "P",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "P",
						"np": 5,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "B",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												31.592,
												0
											],
											[
												38.322,
												-0.496
											],
											[
												46.949,
												-3.596
											],
											[
												53.06,
												-9.196
											],
											[
												56.152,
												-17.317
											],
											[
												55.875,
												-24.503
											],
											[
												53.971,
												-29.573
											],
											[
												50.594,
												-33.667
											],
											[
												45.735,
												-36.507
											],
											[
												49.593,
												-40.357
											],
											[
												54.41,
												-48.339
											],
											[
												53.858,
												-58.049
											],
											[
												49.568,
												-64.893
											],
											[
												42.505,
												-69.173
											],
											[
												33.35,
												-71.061
											],
											[
												7.227,
												-71.094
											],
											[
												7.227,
												0
											]
										],
										"o": [
											[
												35.075,
												-0.032
											],
											[
												44.344,
												-2.287
											],
											[
												51.343,
												-7.047
											],
											[
												55.534,
												-14.339
											],
											[
												56.152,
												-22.656
											],
											[
												54.768,
												-27.986
											],
											[
												51.888,
												-32.438
											],
											[
												47.502,
												-35.717
											],
											[
												47.005,
												-38.428
											],
											[
												53.434,
												-45.337
											],
											[
												54.475,
												-55.175
											],
											[
												51.318,
												-62.899
											],
											[
												45.109,
												-68.017
											],
											[
												36.547,
												-70.67
											],
											[
												29.932,
												-71.094
											],
											[
												7.227,
												-71.094
											],
											[
												7.227,
												0
											]
										],
										"v": [
											[
												31.592,
												0
											],
											[
												41.333,
												-1.392
											],
											[
												49.146,
												-5.322
											],
											[
												54.297,
												-11.768
											],
											[
												56.152,
												-20.703
											],
											[
												55.322,
												-26.245
											],
											[
												52.93,
												-31.006
											],
											[
												49.048,
												-34.692
											],
											[
												43.75,
												-37.061
											],
											[
												51.514,
												-42.847
											],
											[
												54.443,
												-51.855
											],
											[
												52.588,
												-60.474
											],
											[
												47.339,
												-66.455
											],
											[
												39.526,
												-69.922
											],
											[
												29.932,
												-71.094
											],
											[
												7.227,
												-71.094
											],
											[
												7.227,
												0
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												32.324,
												-32.227
											],
											[
												35.856,
												-31.909
											],
											[
												40.12,
												-30.079
											],
											[
												43.001,
												-26.929
											],
											[
												44.385,
												-22.493
											],
											[
												44.068,
												-17.48
											],
											[
												41.926,
												-13.59
											],
											[
												38.395,
												-10.962
											],
											[
												33.642,
												-9.602
											],
											[
												18.994,
												-9.57
											],
											[
												18.994,
												-32.227
											]
										],
										"o": [
											[
												34.179,
												-32.194
											],
											[
												38.851,
												-30.835
											],
											[
												42.203,
												-28.125
											],
											[
												44.108,
												-24.097
											],
											[
												44.385,
												-19.01
											],
											[
												42.798,
												-14.746
											],
											[
												39.713,
												-11.701
											],
											[
												35.335,
												-9.888
											],
											[
												31.787,
												-9.57
											],
											[
												18.994,
												-9.57
											],
											[
												18.994,
												-32.227
											]
										],
										"v": [
											[
												32.324,
												-32.227
											],
											[
												37.354,
												-31.372
											],
											[
												41.162,
												-29.102
											],
											[
												43.555,
												-25.513
											],
											[
												44.385,
												-20.703
											],
											[
												43.433,
												-16.113
											],
											[
												40.82,
												-12.646
											],
											[
												36.865,
												-10.425
											],
											[
												31.787,
												-9.57
											],
											[
												18.994,
												-9.57
											],
											[
												18.994,
												-32.227
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 2,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												18.994,
												-61.426
											],
											[
												30.127,
												-61.426
											],
											[
												33.626,
												-61.189
											],
											[
												38.013,
												-59.846
											],
											[
												41.129,
												-57.178
											],
											[
												42.676,
												-53.108
											],
											[
												42.35,
												-48.25
											],
											[
												40.168,
												-44.685
											],
											[
												36.646,
												-42.309
											],
											[
												31.983,
												-41.194
											],
											[
												18.994,
												-41.162
											]
										],
										"o": [
											[
												18.994,
												-61.426
											],
											[
												31.95,
												-61.393
											],
											[
												36.686,
												-60.44
											],
											[
												40.259,
												-58.219
											],
											[
												42.366,
												-54.638
											],
											[
												42.676,
												-49.69
											],
											[
												41.047,
												-45.743
											],
											[
												37.955,
												-42.96
											],
											[
												33.618,
												-41.431
											],
											[
												30.225,
												-41.162
											],
											[
												18.994,
												-41.162
											]
										],
										"v": [
											[
												18.994,
												-61.426
											],
											[
												30.127,
												-61.426
											],
											[
												35.156,
												-60.815
											],
											[
												39.136,
												-59.033
											],
											[
												41.748,
												-55.908
											],
											[
												42.676,
												-51.318
											],
											[
												41.699,
												-46.997
											],
											[
												39.062,
												-43.823
											],
											[
												35.132,
												-41.87
											],
											[
												30.225,
												-41.162
											],
											[
												18.994,
												-41.162
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "B",
						"np": 6,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												-3.011,
												0.896
											],
											[
												-2.197,
												1.726
											],
											[
												-1.237,
												2.572
											],
											[
												0,
												3.386
											],
											[
												0.553,
												1.742
											],
											[
												1.041,
												1.433
											],
											[
												1.546,
												1.025
											],
											[
												1.985,
												0.554
											],
											[
												-1.921,
												2.49
											],
											[
												-0.033,
												3.516
											],
											[
												1.27,
												2.425
											],
											[
												2.229,
												1.562
											],
											[
												2.979,
												0.749
											],
											[
												3.418,
												0.033
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												3.483,
												-0.032
											],
											[
												3.011,
												-0.895
											],
											[
												2.197,
												-1.725
											],
											[
												1.237,
												-2.571
											],
											[
												0,
												-1.953
											],
											[
												-0.554,
												-1.741
											],
											[
												-1.042,
												-1.432
											],
											[
												-1.546,
												-1.025
											],
											[
												3.255,
												-1.367
											],
											[
												1.92,
												-2.49
											],
											[
												0.032,
												-3.32
											],
											[
												-1.27,
												-2.425
											],
											[
												-2.23,
												-1.562
											],
											[
												-2.979,
												-0.748
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												91.602,
												0
											],
											[
												101.343,
												-1.392
											],
											[
												109.155,
												-5.322
											],
											[
												114.307,
												-11.768
											],
											[
												116.162,
												-20.703
											],
											[
												115.332,
												-26.245
											],
											[
												112.939,
												-31.006
											],
											[
												109.058,
												-34.692
											],
											[
												103.76,
												-37.061
											],
											[
												111.523,
												-42.847
											],
											[
												114.453,
												-51.855
											],
											[
												112.598,
												-60.474
											],
											[
												107.349,
												-66.455
											],
											[
												99.536,
												-69.922
											],
											[
												89.941,
												-71.094
											],
											[
												67.236,
												-71.094
											],
											[
												67.236,
												0
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												-1.498,
												-0.537
											],
											[
												-1.042,
												-0.977
											],
											[
												-0.554,
												-1.416
											],
											[
												0,
												-1.79
											],
											[
												0.635,
												-1.367
											],
											[
												1.106,
												-0.944
											],
											[
												1.53,
												-0.537
											],
											[
												1.855,
												-0.032
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												1.855,
												0.033
											],
											[
												1.497,
												0.537
											],
											[
												1.041,
												0.977
											],
											[
												0.553,
												1.416
											],
											[
												0,
												1.693
											],
											[
												-0.635,
												1.367
											],
											[
												-1.107,
												0.945
											],
											[
												-1.53,
												0.537
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												92.334,
												-32.227
											],
											[
												97.363,
												-31.372
											],
											[
												101.172,
												-29.102
											],
											[
												103.564,
												-25.513
											],
											[
												104.395,
												-20.703
											],
											[
												103.442,
												-16.113
											],
											[
												100.83,
												-12.646
											],
											[
												96.875,
												-10.425
											],
											[
												91.797,
												-9.57
											],
											[
												79.004,
												-9.57
											],
											[
												79.004,
												-32.227
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 2,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.53,
												-0.374
											],
											[
												-1.123,
												-0.813
											],
											[
												-0.619,
												-1.27
											],
											[
												0,
												-1.79
											],
											[
												0.651,
												-1.253
											],
											[
												1.106,
												-0.862
											],
											[
												1.514,
												-0.439
											],
											[
												1.758,
												-0.032
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												1.823,
												0.033
											],
											[
												1.53,
												0.375
											],
											[
												1.123,
												0.814
											],
											[
												0.618,
												1.27
											],
											[
												0,
												1.628
											],
											[
												-0.652,
												1.254
											],
											[
												-1.107,
												0.863
											],
											[
												-1.514,
												0.439
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												79.004,
												-61.426
											],
											[
												90.137,
												-61.426
											],
											[
												95.166,
												-60.815
											],
											[
												99.146,
												-59.033
											],
											[
												101.758,
												-55.908
											],
											[
												102.686,
												-51.318
											],
											[
												101.709,
												-46.997
											],
											[
												99.072,
												-43.823
											],
											[
												95.142,
												-41.87
											],
											[
												90.234,
												-41.162
											],
											[
												79.004,
												-41.162
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "B",
						"np": 6,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "+",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												35.4,
												-58.887
											],
											[
												24.023,
												-58.887
											],
											[
												24.023,
												-39.062
											],
											[
												5.322,
												-39.062
											],
											[
												5.322,
												-28.076
											],
											[
												24.023,
												-28.076
											],
											[
												24.023,
												-7.129
											],
											[
												35.4,
												-7.129
											],
											[
												35.4,
												-28.076
											],
											[
												54.053,
												-28.076
											],
											[
												54.053,
												-39.062
											],
											[
												35.4,
												-39.062
											]
										],
										"o": [
											[
												35.4,
												-58.887
											],
											[
												24.023,
												-58.887
											],
											[
												24.023,
												-39.062
											],
											[
												5.322,
												-39.062
											],
											[
												5.322,
												-28.076
											],
											[
												24.023,
												-28.076
											],
											[
												24.023,
												-7.129
											],
											[
												35.4,
												-7.129
											],
											[
												35.4,
												-28.076
											],
											[
												54.053,
												-28.076
											],
											[
												54.053,
												-39.062
											],
											[
												35.4,
												-39.062
											]
										],
										"v": [
											[
												35.4,
												-58.887
											],
											[
												24.023,
												-58.887
											],
											[
												24.023,
												-39.062
											],
											[
												5.322,
												-39.062
											],
											[
												5.322,
												-28.076
											],
											[
												24.023,
												-28.076
											],
											[
												24.023,
												-7.129
											],
											[
												35.4,
												-7.129
											],
											[
												35.4,
												-28.076
											],
											[
												54.053,
												-28.076
											],
											[
												54.053,
												-39.062
											],
											[
												35.4,
												-39.062
											]
										],
										"c": true
									}
								},
								"nm": "+",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "+",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												95.41,
												-58.887
											],
											[
												84.033,
												-58.887
											],
											[
												84.033,
												-39.062
											],
											[
												65.332,
												-39.062
											],
											[
												65.332,
												-28.076
											],
											[
												84.033,
												-28.076
											],
											[
												84.033,
												-7.129
											],
											[
												95.41,
												-7.129
											],
											[
												95.41,
												-28.076
											],
											[
												114.062,
												-28.076
											],
											[
												114.062,
												-39.062
											],
											[
												95.41,
												-39.062
											]
										],
										"c": true
									}
								},
								"nm": "+",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "+",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/b2b/animations/funnel/data.json
// module id = 1108
// module chunks = 0